// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/NeueFrutigerWorldW02-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: small;
}
html#root,
body#root,
#root#root {
  overflow: hidden;
}
body {
  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;
  overflow: hidden;
}
body * {
  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;
}
* {
  box-sizing: border-box;
}
@font-face {
  font-family: 'NeueFrutigerWorldW02-Regular';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #5a9dbf;
}
::-webkit-scrollbar-thumb:hover {
  background: #5a9dbf;
}
.incompatible {
  border: 0.1rem solid #0000000d;
  border-radius: 4px;
  background-color: #f1f1f1;
}
.incompatible > div:first-child {
  padding-left: 0.1rem !important;
}
.compatible {
  padding-left: 0.15rem;
}
input[type='number'] {
  -moz-appearance: text-field;
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
fieldset.inputFieldset,
.inputFieldsetWithSearchValueMatched {
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
  border-style: solid;
  width: 100%;
  height: fit-content;
  padding-bottom: 4px !important;
}
fieldset.inputFieldset input[type='text'],
.inputFieldsetWithSearchValueMatched input[type='text'],
fieldset.inputFieldset input[type='number'],
.inputFieldsetWithSearchValueMatched input[type='number'] {
  padding: 0.5rem;
}
fieldset.inputFieldset > legend.inputLegend,
.inputFieldsetWithSearchValueMatched > legend.inputLegend {
  color: rgba(0, 0, 0, 0.6);
  word-break: break-all;
  display: flex;
}
fieldset.inputFieldset:focus-within,
.inputFieldsetWithSearchValueMatched:focus-within {
  border-color: #5a9dbf;
}
fieldset.inputFieldset:focus-within > legend.inputLegend,
.inputFieldsetWithSearchValueMatched:focus-within > legend.inputLegend {
  color: #1474a4;
}
fieldset.inputFieldset:hover:not(:focus):not(:focus-within),
.inputFieldsetWithSearchValueMatched:hover:not(:focus):not(:focus-within) {
  border-color: rgba(0, 0, 0, 0.87);
}
fieldset.inputFieldset:hover:not(:focus):not(:focus-within) > legend.inputLegend,
.inputFieldsetWithSearchValueMatched:hover:not(:focus):not(:focus-within) > legend.inputLegend {
  color: rgba(0, 0, 0, 0.87);
}
.MuiOutlinedInput-root {
  width: 100% !important;
}
.numeric-input-field input {
  width: 5ch;
  height: 1rem !important;
}
h6.sectionLayoutHeader {
  margin: 0;
  padding: 0.1rem;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary {
  display: grid !important;
  grid-template-columns: 40% 1fr;
}
.shorten {
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.languageContainer {
  font-size: 1rem !important;
  padding: 0px 0px 0px 0px !important;
  vertical-align: middle !important;
  align-items: center !important;
  border-radius: 0 !important;
  width: max-content;
  top: -1px !important;
}
.dailogFooter {
  background: #eeeeee;
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
}
.navigateTabLabel {
  writing-mode: tb-rl;
  height: inherit;
  cursor: pointer;
  font-size: 1.25rem;
  white-space: nowrap;
}
.tabDrawerMini {
  width: 3rem;
  height: inherit;
  text-align: center;
  background: #eeeeee;
  z-index: 100;
}
.pinIcon {
  font-size: 1.4rem !important;
}
.rotate180 {
  transform: rotate(180deg);
}
.rotate270 {
  transform: rotate(270deg);
}
.rotate90 {
  transform: rotate(90deg);
}
.rotate0 {
  transform: rotate(0deg);
}
.d-flex {
  display: flex;
}
.d-inline-flex {
  display: inline-flex;
}
.d-block {
  display: block;
}
.d-none {
  display: none !important;
}
.d-inline-block {
  display: inline-block;
}
.d-inline {
  display: inline;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.squareSize {
  width: 100%;
  height: 100%;
}
.w-0 {
  width: 0%;
}
.w-25 {
  width: 25%;
}
.w-50 {
  width: 50%;
}
.w-100 {
  width: 100% !important;
}
.w-auto {
  width: auto;
}
.w-25ch {
  width: '25ch';
}
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-40 {
  width: 40%;
}
.w-45 {
  width: 45%;
}
.w-60 {
  width: 60%;
}
.w-90 {
  width: 90%;
}
.mw-0 {
  max-width: 0%;
}
.mw-25 {
  max-width: 25%;
}
.mw-50 {
  max-width: 50%;
}
.mw-100 {
  max-width: 100%;
}
.mw-10 {
  max-width: 10%;
}
.minh-100 {
  min-height: 100%;
}
.h-0 {
  height: 0%;
}
.h-25 {
  height: 25%;
}
.h-50 {
  height: 50%;
}
.h-100 {
  height: 100%;
}
.h-auto {
  height: auto;
}
.m-0 {
  margin: 0;
}
.mt-0 {
  margin-top: 0;
}
.mr-0 {
  margin-right: 0;
}
.mb-0 {
  margin-bottom: 0;
}
.ml-0 {
  margin-left: 0;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.p-0 {
  padding: 0;
}
.p-5px {
  padding: 5px;
}
.p-10px {
  padding: 10px;
}
.p-20px {
  padding: 20px;
}
.p-15px {
  padding: 15px;
}
.p-1rem {
  padding: 1rem;
}
.pt-0 {
  padding-top: 0 !important;
}
.pt-2 {
  padding-top: 2px !important;
}
.pt-10 {
  padding-top: 10px !important;
}
.pl-0 {
  padding-left: 0;
}
.pr-0 {
  padding-right: 0;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-right: 0;
  padding-left: 0;
}
.overflow-auto {
  overflow: auto;
}
.overflowX-auto {
  overflow-x: auto;
}
.overflowY-auto {
  overflow-y: auto;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.text-bold {
  font-weight: bold;
}
.ws-nowrap {
  white-space: nowrap !important;
}
.vertical-middle {
  vertical-align: middle;
}
.align-top {
  align-items: flex-start;
}
.align-center {
  align-items: center;
}
.align-start {
  align-items: start !important;
}
.alignself-center {
  align-self: center;
}
.alignself-start {
  align-self: self-start;
}
.justify-left {
  justify-content: left;
}
.justify-center {
  justify-content: center;
}
.justify-right {
  justify-content: right;
}
.justify-spacebetween {
  justify-content: space-between;
}
.justify-start {
  justify-content: flex-start;
}
.cursor-move {
  cursor: move;
}
.warning {
  color: #ff9800 !important;
}
.bottomUnset {
  border-bottom: unset;
}
.rowFlex {
  display: flex;
  flex-direction: row;
}
.colFlex {
  display: flex;
  flex-direction: column;
}
.squareSize {
  width: 100%;
  height: 100%;
}
.flex-start {
  justify-content: flex-start;
  align-items: flex-start;
}
.cursor-pointer {
  cursor: pointer;
}
.position-absolute {
  position: absolute;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.zindex-100 {
  z-index: 100;
}
.border-radius-0 {
  border-radius: 0 !important;
}
.bg-philips-blue {
  background-color: #1474a4;
}
.bg-lightgray {
  background-color: lightgray;
}
.bg-fadedGray {
  background-color: #9b9b9b;
}
.bg-orange {
  background-color: orange;
}
.b-0 {
  border: 0;
}
.PhilipsBlue {
  color: #1474a4;
}
.auto-included-message {
  font-size: 12px;
  padding: 6px 0px 0px 0px;
}
.conflictDialog-root .header {
  background: #1474a4;
  font-size: 1.2rem !important;
  padding: 0.5rem !important;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
}
.conflictDialog-root .footer {
  background: #eeeeee;
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
}
.conflictDialog-root .tableHeader {
  font-size: 1.2rem !important;
}
.conflictDialog-root .selection {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-wrap: nowrap;
  min-height: 8vh;
  border-bottom: solid 0.1rem #1474a4;
  word-wrap: normal !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
}
.conflictDialog-root .rowText {
  font-size: 0.8rem !important;
  font-weight: bold !important;
  word-break: break-all;
  word-wrap: break-word;
}
.conflictDialog-root .subTableHeader {
  white-space: nowrap !important;
  word-wrap: normal !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
}
.conflictDialog-root .subRowText {
  font-size: 0.75rem !important;
  word-break: break-all;
  word-wrap: break-word;
}
.conflictDialog-root .tabCell {
  padding: 0.2rem 0.3rem 0.2rem !important;
}
.conflictDialog-root .tabHead {
  padding: 0.1rem 0.3rem !important;
}
.conflictDialog-root .conflictDialog-paper {
  width: 45%;
  height: 60vh;
}
.conflictDialog-root .conflictTableInner-root {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}
.conflictDialog-root .guardedConflict {
  height: 40vh;
}
.conflictDialog-root .selectionValue {
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: left;
  vertical-align: middle;
  padding: 0.2rem;
}
.conflictDialog-root .selectionLabel {
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: left;
  vertical-align: middle;
  padding: 0.2rem;
  white-space: nowrap !important;
}
.conflictDialog-root .modelConflict-icon {
  color: #ff9800 !important;
  display: inline-flex;
  max-width: 10%;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  padding: 0.1rem;
}
.conflictDialog-root .collapsibleTableRow > * {
  border-bottom: unset;
}
.conflictDialog-root .collapsibleTable-root {
  height: 38vh;
}
.conflictDialog-root .cancelIcon {
  height: 1.3em;
  width: 1.3em;
  font-size: 1.3rem;
  margin-right: 0.2em;
}
.conflictDialog-root .conflictError {
  display: flex;
  align-items: center;
  padding-top: 1em;
}
.conflictDialog-root .productHeader {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  max-width: 100%;
  color: #1474a4;
}
.conflictDialog-root .sectionSubheader {
  font-weight: bold;
  font-size: 0.95em;
  padding: 6px 0px 4px 4px;
  color: #333;
  background-color: lightgray;
}
.conflictDialog-root .productTableContainer {
  max-width: 100%;
  border: 1px solid #e0e0e0;
}
.conflictDialog-root .feature-column {
  width: 20ch;
  max-width: 150px;
  border-right: 2px solid rgba(191, 201, 205, 0.3) !important;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.conflictDialog-root .option-column {
  width: 20ch;
  max-width: 150px;
  border-right: 2px solid rgba(191, 201, 205, 0.3) !important;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.conflictDialog-root .description-column {
  width: auto;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.conflictDialog-root .feature-header {
  font-weight: bold !important;
  border-right: 2px solid rgba(191, 201, 205, 0.3) !important;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.conflictDialog-root .description-header {
  font-weight: bold !important;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.conflictDialog-root .tableRow:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.conflictDialog-root .tableRow:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.02);
}
.AutoSelectedAssignmentDialog-root .header {
  background: #1474a4;
  font-size: 1.2rem !important;
  padding: 0.5rem !important;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
}
.AutoSelectedAssignmentDialog-root .footer {
  background: #eeeeee;
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
}
.AutoSelectedAssignmentDialog-root .footer .checkbox-container {
  display: flex;
  align-items: center;
}
.AutoSelectedAssignmentDialog-root .footer .checkbox-container .MuiFormControlLabel-root {
  margin: 0;
}
.AutoSelectedAssignmentDialog-root .footer .checkbox-container .MuiFormControlLabel-root .MuiFormControlLabel-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
}
.AutoSelectedAssignmentDialog-root .footer .button-container {
  display: flex;
  gap: 8px;
  align-items: center;
}
.AutoSelectedAssignmentDialog-root .AutoSelectedAssignmentDialog-paper {
  overflow: hidden;
  width: 45%;
  height: 60vh;
}
.AutoSelectedAssignmentDialog-root .selectionValue {
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: left;
  vertical-align: middle;
  padding: 0.2rem;
}
.AutoSelectedAssignmentDialog-root .selectionLabel {
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: left;
  vertical-align: middle;
  padding: 0.2rem;
  white-space: nowrap !important;
}
.AutoSelectedAssignmentDialog-root .selection {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-wrap: nowrap;
  min-height: 4vh;
  border-bottom: solid 0.1rem #1474a4;
  word-wrap: normal !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  flex-shrink: 0;
}
.AutoSelectedAssignmentDialog-root .tableContainer {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  table-layout: fixed;
  width: 100%;
}
.AutoSelectedAssignmentDialog-root .productTableContainer {
  max-width: 100%;
  border: 1px solid #e0e0e0;
}
.AutoSelectedAssignmentDialog-root .productTableContainer .MuiTable-root {
  table-layout: fixed;
  width: 100%;
}
.AutoSelectedAssignmentDialog-root .tabCell {
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  padding: 4px 4px;
  font-size: 0.875rem;
  line-height: 1.2;
  letter-spacing: 0.01071em;
}
.AutoSelectedAssignmentDialog-root .tabCell:last-child {
  border-right: none;
}
.AutoSelectedAssignmentDialog-root .tabCell.feature-column {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.AutoSelectedAssignmentDialog-root .tabCell.option-column {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.AutoSelectedAssignmentDialog-root .tabCell.description-column {
  width: auto;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.AutoSelectedAssignmentDialog-root .tabHead {
  background-color: #f5f5f5;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.AutoSelectedAssignmentDialog-root .tabHead:last-child {
  border-right: none;
}
.AutoSelectedAssignmentDialog-root .tableRow:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.AutoSelectedAssignmentDialog-root .tableRow:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.02);
}
.AutoSelectedAssignmentDialog-root .noDataMessage {
  color: rgba(0, 0, 0, 0.6);
  font-style: italic;
  padding: 2rem;
  text-align: center;
}
.AutoSelectedAssignmentDialog-root .scrollableContent {
  max-height: 354px;
  overflow-y: auto;
  overflow-x: hidden;
}
.AutoSelectedAssignmentDialog-root .scrollableContent .productSection {
  margin-top: 2vh;
  width: 41.6vw;
}
.AutoSelectedAssignmentDialog-root .scrollableContent .productSection .MuiTable-root {
  table-layout: fixed;
  width: 100%;
}
.AutoSelectedAssignmentDialog-root .dialogContent {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 70vh;
}
.AutoSelectedAssignmentDialog-root .dialogContent .auto-included-message {
  padding: 4px 0px 0px 0px;
  flex-shrink: 0;
  font-size: 12px;
}
.AutoSelectedAssignmentDialog-root .productHeader {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  text-align: center;
  font-weight: bold;
  font-size: 1.1rem;
  max-width: 100%;
  color: #1474a4;
}
.AutoSelectedAssignmentDialog-root .sectionSubheader {
  font-weight: bold;
  font-size: 0.95em;
  padding: 6px 0px 4px 4px;
  color: #333;
  background-color: lightgray;
}
.AutoSelectedAssignmentDialog-root .AutoSelectedAssignmentDialog-root .productId {
  color: #1474a4 !important;
  font-weight: bold !important;
}
.AutoSelectedAssignmentDialog-root .productTableContainer {
  max-width: 100%;
  border: 1px solid #e0e0e0;
}
.AutoSelectedAssignmentDialog-root .feature-column {
  width: 20ch;
  max-width: 150px;
  border-right: 2px solid rgba(191, 201, 205, 0.3) !important;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.AutoSelectedAssignmentDialog-root .option-column {
  width: 20ch;
  max-width: 150px;
  border-right: 2px solid rgba(191, 201, 205, 0.3) !important;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.AutoSelectedAssignmentDialog-root .description-column {
  width: auto;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.AutoSelectedAssignmentDialog-root .feature-header {
  font-weight: bold !important;
  border-right: 2px solid rgba(191, 201, 205, 0.3) !important;
  font-size: 0.95rem;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.AutoSelectedAssignmentDialog-root .description-header {
  font-weight: bold !important;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.configurator-root {
  padding-bottom: 5px !important;
}
.configurator-root.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}
.configurator-root .configurator-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  height: 100% !important;
}
.configurator-root .configurator-content-with-disclaimer {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  height: 93% !important;
}
.configurator-root .medium-configurator-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  height: 94.5% !important;
}
.configurationSummary-root.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0 5px;
}
.configurationSummary-root > .MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded {
  box-sizing: border-box;
  border: 2px solid transparent;
  border-radius: 4px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24);
  background-color: #eee;
}
.configurationSummary-root .MuiCollapse-root.MuiCollapse-vertical {
  background-color: #fff;
}
.configurationSummary-root > .MuiPaper-elevation1.MuiAccordion-root:first-of-type {
  margin-top: 10px;
}
.configurationSummary-root > .MuiPaper-elevation1.MuiAccordion-root:last-of-type {
  margin-bottom: 10px;
}
.configurationSummary-root .MuiAccordion-root.Mui-expanded {
  margin: 10px 0 0;
}
.configurationSummary-root > .MuiPaper-elevation1.MuiAccordion-root img {
  vertical-align: middle;
  height: 1.5rem;
  width: 2rem;
  object-fit: scale-down;
}
.configurationSummary-root > .MuiPaper-elevation1.MuiAccordion-root .MuiAccordionSummary-content {
  width: 90%;
  justify-self: left;
  align-items: center;
}
.configurationSummary-root > .MuiPaper-elevation1.MuiAccordion-root .MuiAccordionSummary-expandIconWrapper {
  width: 10%;
  justify-self: right;
  justify-content: center;
}
.configurationSummary-root .MuiAccordionSummary-content h6,
.configurationSummary-root .MuiAccordionSummary-content .modelPrice span {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.configurationSummary-root .MuiAccordionSummary-content .modelPrice span {
  margin-left: auto;
}
.configurationSummary-root .MuiAccordionSummary-content.Mui-expanded .summary-accordionHead .summary-accordionHeadTitle {
  word-wrap: break-word;
  text-overflow: initial;
  white-space: initial;
}
.configurationSummary-root .MuiAccordionSummary-content.Mui-expanded .summary-accordionHead .summary-accordionHeadTitle.required:after {
  display: inline;
  content: '*';
  color: red;
}
.configurationSummary-root .MuiAccordionSummary-content.Mui-expanded .summary-accordionHead .asterisk {
  display: none;
}
.configurationSummary-root .MuiAccordionSummary-content.Mui-expanded h6,
.configurationSummary-root .MuiAccordionSummary-content.Mui-expanded .modelPrice span {
  word-wrap: break-word;
  text-overflow: initial;
  white-space: initial;
}
.configurationValidationDialog-root .header {
  background: #1474a4;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
  padding: 0.49rem !important;
}
.configurationValidationDialog-root .footer {
  background: #eeeeee;
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
}
.configurationValidationDialog-root .message {
  color: red;
  font-size: 1rem !important;
  font-weight: bold !important;
  padding: 0.8rem 0.5rem;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
}
.configurationValidationDialog-root .tableHeader {
  font-size: 1.3rem !important;
  font-weight: bold !important;
}
.configurationValidationDialog-root .subRowText {
  font-size: 0.8rem !important;
  word-break: break-all;
  word-wrap: break-word;
}
.configurationValidationDialog-root .rowText {
  font-size: 0.8rem !important;
  word-break: break-all;
  word-wrap: break-word;
  font-weight: bold !important;
}
.configurationValidationDialog-root .removedSubRowText {
  font-size: 0.8rem !important;
  word-break: break-all;
  word-wrap: break-word;
  color: red !important;
}
.configurationValidationDialog-root .subTableHeader {
  font-size: 0.9rem !important;
  font-weight: bold !important;
}
.configurationValidationDialog-root .tabCell {
  padding: 0.5rem !important;
}
.configurationValidationDialog-root .configurationValidationDialog-paper {
  width: 75% !important;
  height: 75vh !important;
}
.configurationValidationDialog-root .innerTable {
  overflow-y: auto;
  margin-left: auto;
  margin-right: auto;
  height: 45vh;
}
.configurationValidationDialog-root .collapsibleTableRow > * {
  border-bottom: unset;
}
.configurationValidationDialog-root .collapsibleTable {
  overflow: auto;
  margin-left: auto;
  margin-right: auto;
  height: 45vh;
}
.configurationValidationDialog-root .tabSection-root {
  border-bottom: 1px solid;
  border-color: rgba(0, 0, 0, 0.12);
}
.configurationValidationDialog-root .tabSection-root .tab-button {
  padding: 0.5rem;
  text-transform: capitalize;
  flex-direction: row;
}
.configurationValidationDialog-root .tabSection-root .tab-badge {
  text-align: center;
  vertical-align: middle;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.8rem;
  margin-left: 0.3rem;
}
.configurationValidationDialog-root .tabSection-root .tab-badge.selected {
  background-color: #1474a4;
}
.configurationValidationDialog-root .tabSection-panel {
  padding: 0 1.3rem;
  height: 48vh;
}
.footer.root {
  display: flex;
  width: 100%;
  font-size: 12px;
  justify-content: space-between;
  padding-left: 1em;
  padding-right: 1em;
  align-items: center;
}
.footer .env {
  margin-right: 1px;
  padding-right: 1px;
}
.footer .termsAndCondition {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.footer.bg-gray {
  background-color: #eeeeee;
}
.footer.bg-green {
  background-color: #93c47d;
}
.footer.bg-orange {
  background-color: #f6b26b;
}
.footer.bg-yellow {
  background-color: #f3f66b;
}
.termsAndCondition-dialog .paperClass {
  width: 45%;
  max-height: 60vh;
  overflow-y: auto;
}
.termsAndConditionStyle {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.termsAndConditionStyle .title {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.sectionLayout {
  padding: 0px 20px;
}
.viewError {
  margin: 20px 0px 0px 0px !important;
}
.userPanelIconButton {
  cursor: pointer;
  color: white !important;
  padding: 5px !important;
}
.userPanelIconButton .userProfileIcon {
  height: 2rem;
  width: 2rem;
}
.popperStyle.arrow {
  width: 3em;
  height: 3em;
}
.popperStyle::before {
  content: '';
  margin: auto;
  display: block;
  width: 0%;
  border-style: solid;
  border-width: 0px 1em 1em;
  border-color: transparent transparent #ffffff;
  margin-top: -0.4rem;
}
.activeIcon {
  color: #eeeeee !important;
  background-color: #1474a4 !important;
}
.infoDialogIcon {
  margin: 0 !important;
  padding: 3px !important;
}
.familyInfoDialogIcon {
  padding: 3px !important;
}
.validation-error {
  color: red !important;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 1rem !important;
}
.success {
  color: #9dc183 !important;
}
.txt-field {
  padding: 0px 4px !important;
  width: fit-content;
}
.bg-red {
  background-color: red;
}
.color-red {
  color: red;
}
.btn-ok {
  float: right;
  padding-top: 15px;
}
.btn-disabled {
  color: #eeeeee;
}
.btn-decrement-disabled {
  color: darkgray;
}
.btn-decrement {
  color: #fa8072;
}
.btn-increment {
  color: #9dc183;
}
.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.left-arrow {
  color: #1474a4;
  margin-left: 80%;
}
.drawerOpen {
  width: 200px;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {
  text-transform: capitalize !important;
  align-items: center;
  justify-content: left;
  text-align: left;
  min-height: 30px;
  padding: 10px;
  color: rgba(0, 0, 0, 0.87) !important;
}
.headerStyle.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.headerStyle .toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  min-height: 3rem;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}
.headerStyle .toolbarSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.headerStyle .tooltip {
  margin: 2;
}
.headerStyle .button-icon {
  cursor: pointer;
  color: #ffffff;
}
.headerStyle .message {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  color: #f7d368;
}
.headerStyle .headerBanner {
  margin-left: 0.5em;
}
.headerStyle .headerBanner.state.readOnly .icon {
  color: #d2cbcb !important;
}
.headerStyle .headerBanner.state.readOnly .message {
  color: #d2cbcb !important;
}
.headerStyle .icon {
  height: 100% !important;
  width: 2em !important;
  color: #f7d368;
}
.orderingIntstuctionsStyle .table-container {
  overflow-x: inherit;
}
.orderingIntstuctionsStyle .activeBorder {
  border-bottom: 1px solid;
  border-color: #00000033;
}
.orderingIntstuctionsStyle .inactiveBorder {
  border-bottom: 0;
}
.orderingIntstuctionsStyle .table-cell {
  border: 1px solid #eeeeee;
  padding: 5px;
}
.languageSelectionDialogStyle .form-control {
  margin: 20px 0 0 0;
}
.sectionStyle .title {
  margin: 0;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  word-break: break-all;
}
.sectionStyle,
.sectionStyle .height-fit-content {
  height: fit-content;
}
.infoDialogStyle .paper {
  width: 80% !important;
  height: 80vh !important;
  max-width: 100% !important;
}
.infoDialogStyle .summary {
  width: 100%;
  display: grid !important;
  grid-template-columns: 40% 1fr;
}
.infoDialogStyle .shorten {
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.infoDialogStyle .title {
  align-items: center;
  height: auto;
}
.infoDialogStyle .infoDialogTitle {
  width: 90%;
}
.infoDialogStyle .dialog-box {
  border-bottom: 1px solid;
  border-color: rgba(0, 0, 0, 0.12);
}
.infoDialogStyle .dialog-tab {
  padding: 0.5rem;
  text-transform: capitalize !important;
  flex-direction: row;
}
.infoDialogStyle .dialog-panel {
  padding: 1rem;
  padding-top: 0;
  padding-bottom: 0;
  height: 60vh;
  overflow-y: auto;
  margin-left: auto;
  margin-right: auto;
}
.infoDialogStyle .dialog-panel .salesTextAccordion-root {
  border: 1px solid #eeeeee;
  border-top: none;
  padding: 0;
  margin: 0;
}
.infoDialogStyle .dialog-panel .salesTextAccordion-root:first-of-type {
  border-top: 1px solid #eeeeee;
  margin-top: 1rem;
}
.infoDialogStyle .dialog-panel .salesTextAccordion-root .summary > div {
  padding: 0.2rem;
}
.infoDialogStyle .dialog-panel .salesTextAccordion-root .summary .shorten {
  color: #1474a4;
  font-weight: bold;
  padding-left: 0.5rem;
  border-left: 1px solid #eeeeee;
  vertical-align: middle;
}
.infoDialogStyle .dialog-panel .salesTextAccordion-root .summary .shorten > span {
  color: black;
  font-weight: normal;
}
.infoDialogStyle .dialog-panel .salesTextAccordion-root .summary-expanded {
  padding: 0.2rem;
}
.infoDialogStyle .dialog-panel .salesTextAccordion-root .content {
  padding: 0.2rem;
}
.infoDialogStyle .MuiTabs-indicator {
  height: 2px;
}
.infoDialogStyle .imageGrid {
  height: 100% !important;
  padding: 24px;
}
.infoDialogStyle .MuiDialogContent-root {
  padding-bottom: 0px !important;
}
.error-dialog-style .MuiDialog-paper {
  width: 25%;
}
.common-dialog-style .header {
  background-color: #1474a4;
  font-size: 1.2rem;
  padding: 0.5rem;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
}
.common-dialog-style .paper {
  height: 60vh;
}
.common-dialog-style .closeIcon {
  position: absolute;
  right: 8px;
  top: 0px;
  color: #fff;
}
.common-dialog-style .footer {
  background: #eeeeee;
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
}
.dragger {
  width: 5px;
  cursor: ew-resize;
  padding: 4px 0 0;
  border-top: 1px solid #ddd;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background-color: #f4f7f9;
}
.drawer-class {
  height: inherit;
  overflow: hidden !important;
  z-index: 1;
}
.infoPanelStyle.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  transition: 0.15s;
  padding: 10px;
  overflow: hidden;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  background: #eeeeee;
  min-width: 345px;
  margin: 0;
  flex-shrink: 0;
}
.infoPanelStyle.rootNew {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  transition: 0.15s;
  padding: 10px;
  overflow: hidden;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  background: #eeeeee;
  min-width: 345px;
  margin: 0;
  flex-shrink: 0;
  height: 80% !important;
}
.infoPanelStyle.mobileView {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  transition: 0.15s;
  padding: 10px;
  overflow: hidden;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  background: #eeeeee;
  min-width: 345px;
  margin: 0;
  flex-shrink: 0;
  height: 82% !important;
}
.infoPanelStyle.summaryViewHeight {
  height: 91.5% !important;
}
.infoPanelStyle .content {
  overflow-wrap: anywhere;
}
.infoPanelStyle.disabled,
.infoPanelStyle .disabled {
  min-width: 0;
  width: 0%;
  padding: 0;
  overflow: hidden;
}
.infoPanelStyle .disabledContent {
  margin: 0;
}
.infoPanelStyle.hover {
  position: absolute;
  right: 0;
  bottom: 0;
  box-shadow: -8px 0 8px -8px black;
  z-index: 15;
  height: unset;
}
.infoPanelStyle .rootPrice {
  width: 100% !important;
  padding: 0 10px;
}
.infoPanelStyle .rootPrice .rowFlex1 {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.infoPanelStyle .title {
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.334;
  margin: 1em 0px 10px 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.32);
}
.infoPanelStyle .priceTitle {
  font-weight: bold;
  font-size: 1rem;
  font-family: NeueFrutigerWorldW02-Regular;
}
.infoPanelStyle .box-iconbtn {
  color: #1474a4;
  position: absolute;
  padding: 0;
  align-self: self-start;
}
.infoPanelStyle .box-table {
  margin-bottom: 5px;
}
.infoPanelStyle.extraSmallHeaderHeight {
  top: 89px;
}
.infoPanelStyle.headerHeight {
  top: inherit;
}
.infoPanelStyle .box-openInbtn {
  position: absolute;
  padding: 0;
  align-self: self-end;
}
.appRouter.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 0;
}
.appRouter .secondaryHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.appRouter .appRouterContent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.appRouter .divider {
  width: 100%;
}
.home-icon {
  color: #1474a4 !important;
  width: 100%;
  padding: 3px !important;
  margin: 0px !important;
}
.breadCrumb.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0 10px;
}
.breadCrumb .MuiBreadcrumbs-separator {
  margin: 0px !important;
}
.breadCrumb .item {
  color: #1474a4;
  text-overflow: ellipsis;
  max-width: 15em;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
}
.breadCrumb .activeItem {
  font-weight: bold;
}
.configureError .title {
  color: #ff9800;
  background: #1474a4;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0px 8px;
}
.configureError .listItem {
  margin: 0 0 0 20px;
  list-style-type: disc;
}
.configureError .header {
  background: #1474a4;
  font-size: 1.2rem !important;
  padding: 0.5rem !important;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
}
.configureError .footer {
  background: #eeeeee;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.configureError .dialogContent {
  padding: 15px 15px 15px 15px;
  min-width: 300px;
}
.variableSummary.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 5px 0;
}
.variableSummary section {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.variableSummary content {
  width: 100%;
  overflow: hidden;
}
.variableSummary .tableCell {
  width: 45%;
  border: none;
  word-break: break-all;
}
.variableSummary .headTableCell {
  border: none;
}
.variableSummary .fullWidthborder {
  border-bottom: 1px solid #e0e0e0;
}
.variableSummary .variableName {
  color: #1474a4 !important;
  font-weight: 800;
  border: none;
  padding-top: 0px;
  padding-bottom: 1px;
}
.variableSummary .optionalValue {
  color: darkgrey !important;
}
.sectionSummary.root {
  margin-top: 10px;
  width: 100%;
}
.sectionSummary.content,
.sectionSummary .content {
  width: 100%;
  font-weight: normal;
}
.sectionSummary .contentHead {
  font-size: 1rem;
  margin: 0px;
}
.sectionSummary .contentBody {
  padding-left: 0.2rem;
  font-size: 0.9rem;
}
.sectionSummary .accordionHead {
  font-size: 1rem;
  font-weight: bold;
  vertical-align: middle;
  margin: 0px;
}
.sectionSummary .summary-accordionHead {
  font-size: 1rem;
  font-weight: bold;
  vertical-align: middle;
  margin: 0px;
  display: flex;
  align-items: center;
}
.sectionSummary .summary-accordionHead .summary-accordionHeadTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sectionSummary .summary-accordionHead .summary-accordionHeadTitle.required:after {
  display: none;
}
.sectionSummary .summaryAccordionHeader {
  display: inline-flex;
  width: 60%;
  justify-content: left;
  text-align: left;
  justify-self: left;
  align-items: center;
  padding: 0;
}
.sectionSummary .summary-accordianTitle {
  display: flex;
  width: 80%;
}
.sectionSummary .modelPrice {
  display: inline-flex;
  max-width: 40%;
  justify-content: right;
  text-align: right;
  align-items: center;
  justify-self: right;
  padding: 0;
  margin-left: auto;
  word-break: break-all;
}
.sectionSummary .acSummary {
  align-items: center;
  min-height: 2.5rem !important;
}
.sectionSummary .divider {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.currencyContainer .symbol {
  padding-left: 0.3rem;
  font-size: 1.3rem !important;
  margin: 0 0.5px;
}
.currencyContainer svg {
  font-size: 1.6rem !important;
}
.messagesIcon {
  padding-top: 2px;
}
.messagesIcon .messageBadge .MuiBadge-badge {
  transform: scale(0.7) translate(30%, -30%) !important;
}
.orangeBadge .messageBadge .MuiBadge-badge {
  background-color: orange;
}
.grayBadge .messageBadge .MuiBadge-badge {
  background-color: #9b9b9b;
}
.popoverPaper .MuiPaper-root {
  display: flex;
  flex-direction: column;
}
.eraserIcon {
  min-width: 0px !important;
  border-radius: 50% !important;
  top: 0.5px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.eraserIcon:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
.stateIcon {
  color: #f7d368;
}
.errorIcon {
  color: #fa5a4b;
  position: relative;
  top: 4px;
}
.required:after {
  content: '*';
  font-weight: bold;
  color: red;
}
.asterisk {
  font-weight: bold;
  color: red;
}
.priceHeader {
  padding-right: 0.5em;
}
.clearAllButton {
  margin-left: -0.3em !important;
}
.noSelectableMessage {
  justify-content: center;
  width: 100%;
}
.noTextMessage {
  display: flex;
  justify-content: center;
  height: -webkit-fill-available;
  align-items: center;
}
.myConfigurations-Tab {
  width: 84%;
  display: block;
  padding: 0px 0px 10px 10px;
  overflow: auto;
}
.myConfigurations-list-Tab {
  height: calc(87% - 4.6rem);
  display: block;
  overflow: auto;
  margin-top: 6px;
}
.list-Section {
  display: block;
  height: calc(86% - 4.6rem);
  overflow: auto;
  padding: 0px 10px 10px 10px;
}
.list-Section ul > div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.list-Section-Tab {
  display: block;
  width: 84%;
  overflow: auto;
}
.list-Section::-webkit-scrollbar {
  height: 10px;
}
.landing-Page {
  display: block;
  width: 100%;
  height: 100%;
}
.list-Items {
  padding-top: 0px !important;
}
.prod-list {
  color: #1474a4 !important;
  text-decoration: underline !important;
  max-width: 300px !important;
  padding-bottom: 4px !important;
  padding-left: 0px !important;
  padding-top: 4px !important;
  word-break: break-all;
}
.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-endAdornment {
  right: 0 !important;
}
.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-endAdornment .MuiIconButton-root {
  margin-right: 0;
  padding: 8px;
}
.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  height: 1rem;
}
.search-bar.MuiAutocomplete-root {
  width: 20em !important;
  position: relative;
  bottom: 3px;
  right: 5.5px;
  padding-top: 0.5rem;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div > div > button {
  visibility: visible !important;
}
.search-bar {
  margin: 0px !important;
}
.create-configuration-dialog .MuiDialog-container .MuiPaper-root {
  width: 100%;
  max-width: 30%;
  height: auto !important;
  max-height: 65%;
}
.create-configuration-dialog .MuiDialog-container .MuiPaper-root .MuiDialogContent-root {
  padding-top: 1.5em;
}
.create-configuration-dialog .errorMessage {
  margin-top: 0.5vh;
  max-width: unset !important;
  height: unset !important;
}
.create-configuration-dialog .formActionButtons {
  display: flex;
  justify-content: flex-end;
  bottom: 0;
  position: absolute;
  width: 100%;
  left: 0;
  padding-bottom: 1em;
  padding-right: 1.5em;
}
.create-configuration-dialog .formActionButtons button {
  margin-right: 0.5em;
}
.headers {
  background: #1474a4;
  font-size: 1.2rem !important;
  padding: 0.5rem !important;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
}
.MuiTabPanel-root {
  padding-left: 16px !important;
  padding-top: 0px !important;
}
.detailedSummaryDialogStyle .paper {
  width: 85% !important;
  height: 110vh !important;
  max-width: 100% !important;
}
.detailedSummaryDialogStyle .summary {
  width: 100%;
  display: grid !important;
  grid-template-columns: 40% 1fr;
}
.detailedSummaryDialogStyle .shorten {
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.detailedSummaryDialogStyle .title {
  height: auto;
  text-align: center;
}
.detailedSummaryDialogStyle .check {
  padding: 0 !important;
}
.detailedSummaryDialogStyle .contents {
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.detailedSummaryDialogStyle .leftBar,
.detailedSummaryDialogStyle .leftBar-mobile {
  border-right: 1px solid #e0e0e0;
  width: 20%;
}
.detailedSummaryDialogStyle .leftBar .MuiAutocomplete-inputRoot,
.detailedSummaryDialogStyle .leftBar-mobile .MuiAutocomplete-inputRoot {
  border-radius: 0;
}
.detailedSummaryDialogStyle .leftBar .defaultExpandIcon,
.detailedSummaryDialogStyle .leftBar-mobile .defaultExpandIcon {
  color: #0062a1;
}
.detailedSummaryDialogStyle .leftBar .defaultCollapseIcon,
.detailedSummaryDialogStyle .leftBar-mobile .defaultCollapseIcon {
  color: #0078ce;
}
.detailedSummaryDialogStyle .leftBar .defaultEndIcon,
.detailedSummaryDialogStyle .leftBar-mobile .defaultEndIcon {
  color: #00abeb;
}
.detailedSummaryDialogStyle .leftBar .detailedSummaryTree,
.detailedSummaryDialogStyle .leftBar-mobile .detailedSummaryTree {
  height: 90%;
  max-width: 100%;
  overflow-y: auto;
}
.detailedSummaryDialogStyle .leftBar .detailedSummarySearchBar,
.detailedSummaryDialogStyle .leftBar-mobile .detailedSummarySearchBar {
  width: 100% !important;
  margin: 0px !important;
}
.detailedSummaryDialogStyle .leftBar .detailedSummarySearchBar .innerTextField > div,
.detailedSummaryDialogStyle .leftBar-mobile .detailedSummarySearchBar .innerTextField > div {
  padding-top: 0% !important;
  padding-bottom: 0% !important;
}
.detailedSummaryDialogStyle .leftBar .detailedSummarySearchBar .innerTextField > div > div > button,
.detailedSummaryDialogStyle .leftBar-mobile .detailedSummarySearchBar .innerTextField > div > div > button {
  visibility: visible !important;
}
.detailedSummaryDialogStyle .leftBar-mobile {
  overflow: hidden;
}
.detailedSummaryDialogStyle .rightBar {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.detailedSummaryDialogStyle .rightBar .tableHead {
  position: sticky;
  top: 0;
}
.detailedSummaryDialogStyle .rightBar .MuiTableCell-root {
  vertical-align: baseline;
}
.detailedSummaryDialogStyle .rightBar .PriceFooter {
  display: flex;
  background-color: #1d93cf;
  color: #fff;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  -height: 1.5rem;
  letter-spacing: 0.01071em;
  vertical-align: inherit;
  text-align: left;
  -content: space-between;
  padding-left: 16px;
  padding-right: 16px;
}
.detailedSummaryDialogStyle .rightBar tbody th {
  padding-top: 0.2em;
  padding-bottom: 0em;
  border: 0;
}
.detailedSummaryDialogStyle .rightBar .totalPrice {
  position: fixed;
  top: 103vh;
  bottom: 0;
  width: -webkit-fill-available;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e0e0e0;
  background-color: #1d93cf;
  color: white !important;
}
.detailedSummaryDialogStyle .rightBar .totalPrice th {
  color: #fff !important;
}
.detailedSummaryDialogStyle .rightBar .sectionRow {
  background: #eeee;
}
.detailedSummaryDialogStyle .dialog-box {
  border-bottom: 1px solid;
  border-color: rgba(0, 0, 0, 0.12);
}
.detailedSummaryDialogStyle .dialog-panel {
  padding: 1rem;
  padding-top: 0;
  padding-bottom: 0;
  height: 53vh;
  overflow-y: auto;
  margin-left: auto;
  margin-right: auto;
}
.detailedSummaryDialogStyle .dialog-panel .salesTextAccordion-root {
  border: 1px solid #eeeeee;
  border-top: none;
  padding: 0;
  margin: 0;
}
.detailedSummaryDialogStyle .dialog-panel .salesTextAccordion-root:first-of-type {
  border-top: 1px solid #eeeeee;
  margin-top: 1rem;
}
.detailedSummaryDialogStyle .dialog-panel .salesTextAccordion-root .summary > div {
  padding: 0.2rem;
}
.detailedSummaryDialogStyle .dialog-panel .salesTextAccordion-root .summary .shorten {
  color: #1474a4;
  font-weight: bold;
  padding-left: 0.5rem;
  border-left: 1px solid #eeeeee;
  vertical-align: middle;
}
.detailedSummaryDialogStyle .dialog-panel .salesTextAccordion-root .summary .shorten > span {
  color: black;
  font-weight: normal;
}
.detailedSummaryDialogStyle .dialog-panel .salesTextAccordion-root .summary-expanded {
  padding: 0.2rem;
}
.detailedSummaryDialogStyle .dialog-panel .salesTextAccordion-root .content {
  padding: 0.2rem;
}
.action-panel-dialog-content {
  padding-top: 1em !important;
  padding-bottom: 1em !important;
}
.action-panel-dialog-content p {
  letter-spacing: 0px !important;
}
.configurationAccordian .img {
  height: 75px;
  width: auto;
}
.configurationAccordian .imageFlex {
  width: 5%;
  min-width: 30px;
  text-align: left !important;
}
.configurationAccordian .productIdFlex {
  width: 7%;
  min-width: 100px;
  text-align: left !important;
}
.configurationAccordian .productDescriptionFlex {
  width: 25%;
  min-width: 100px;
  text-align: left !important;
}
.configurationAccordian .configIdFlex {
  width: 15%;
  min-width: 100px;
  text-align: left !important;
}
.configurationAccordian .stateFlex {
  width: 7%;
  min-width: 100px;
  text-align: left !important;
}
.configurationAccordian .dateFlex {
  width: 25%;
  min-width: 100px;
  text-align: left !important;
}
.configurationAccordian .tableCellLeft {
  text-align: left !important;
}
.configurationAccordian .imageCenter {
  display: flex;
  justify-content: center;
}
.configurationAccordian .accordionIcon {
  margin-right: 10px;
}
.configurationAccordian .myConfigPanel {
  overflow-x: 'auto !important';
  height: '40vh !important';
}
.zoom80 {
  zoom: 80%;
}
.action-panel-buttons {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.paddingTopBottom {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.sales-text-dialog {
  padding-left: 10px !important;
}
.ordering-instructions-dialog {
  padding-left: 10px !important;
}
.ordering-instructions-dialog .MuiTableCell-root {
  padding: 1rem !important;
}
.iconCheck,
.updateIcon {
  padding: 0 !important;
  margin: 0px 4px !important;
}
.iconNumeric {
  padding: 0 !important;
  margin: 0px 4px 0px 0px !important;
}
.submodelIcon {
  padding: 0 !important;
  margin: 0.5px 8px 0px 0px !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {
  color: #1474a4 !important;
  background: #c7e0f4 !important;
  font-weight: 800 !important;
}
.MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused {
  background: #c7e0f4 !important;
  color: #1474a4 !important;
  font-weight: bold;
}
.closeWithoutSave-icon {
  color: gray !important;
}
.notify-icon {
  color: #1474a4 !important;
}
#demo-simple-select-label {
  top: -6px !important;
}
.cardLayoutMainDiv {
  display: flex;
  justify-content: space-start;
  padding: 0px;
  align-items: center;
  margin: -12px;
  width: 100%;
}
.cardLayoutChildProdDiv {
  display: flex !important;
  flex-direction: column !important;
  width: 100%;
}
.cardLayoutChildProdDiv .InnoSight.System {
  display: flex !important;
}
.cardLayoutChildProdDiv .product-description,
.cardLayoutChildProdDiv .product-id {
  color: #1474a4;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: baseline;
  line-height: 1.2;
}
.cardLayoutChildProdDiv .product-description {
  max-width: 65%;
}
.overflow-country {
  white-space: nowrap;
  width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cardLayoutChildDiv {
  display: flex !important;
  flex-direction: column !important;
}
.cardLayoutChildDiv .configurationName {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 95%;
}
.fullScreenImage {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30vh !important;
  width: auto;
  text-align: center;
  position: relative;
}
.fullScreenImage img {
  max-width: 100% !important;
  max-height: 100% !important;
  pointer-events: none;
  width: fit-content;
  height: fit-content;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 13px 27px -5px hsla(240, 30.1%, 28%, 0.25), 0 8px 16px -8px hsla(0, 0%, 0%, 0.3), 0 -6px 16px -6px hsla(0, 0%, 0%, 0.03);
}
.slider-wrapper {
  width: 97%;
  height: 15%;
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
}
.slick-slide img {
  padding-inline: 0.5rem;
  cursor: pointer;
  max-width: 100%;
  height: auto;
}
.slick-slide img:hover {
  transform: scale(1.12);
}
.slick-next {
  right: -1.5rem !important;
}
.slick-prev {
  right: -30px !important;
}
.slick-next:before,
.slick-prev:before {
  color: #1474a4 !important;
  font-weight: bold;
}
.next-slick-arrow,
.prev-slick-arrow {
  color: #000000;
  font-size: 3rem;
}
.slick-slide {
  text-align: center;
  position: relative;
}
.slick-slider {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.slick-prev {
  left: -19px !important;
}
.breadcrumbs-li,
.MuiBreadcrumbs-li {
  display: contents !important;
}
.text-uppecase {
  text-transform: uppercase !important;
}
.arrowIcon {
  color: rgba(0, 0, 0, 0.87) !important;
}
.slick-prev,
.slick-next {
  top: 50% !important;
}
.productImageDialog {
  overflow-y: hidden !important;
  height: auto !important;
}
.noImageGrid {
  height: 60vh !important;
}
.exportIcon {
  color: #1474a4 !important;
}
.detailedExportIcon {
  position: absolute !important;
  color: #fff !important;
  right: 2em;
  top: 0px;
}
.quickExportIcon {
  position: absolute !important;
  padding: 0 !important;
  align-self: self-end !important;
  margin-right: 1.5em !important;
}
@media only screen and (max-width: 450px) {
  .detailedSummaryDialogStyle .title {
    text-align: inherit !important;
  }
  .detailedExportIcon {
    right: 1.5em;
  }
}
.product-portfolio {
  height: 100%;
  padding: 0px !important;
}
.myConfiguration-tab {
  height: 100%;
  padding: 0px !important;
}
.list-ItemsContainer {
  margin-left: 0px !important;
}
.catalog-Container {
  width: 400px;
  height: 125px;
}
.catalog-cardLayout {
  padding: 5px !important;
}
.catalog-cardLayout > div {
  display: flex !important;
}
.catalog-image {
  height: 80px;
  width: 80px;
  margin-left: 5px;
  margin-top: 5px;
}
.catalog-info {
  margin-left: 10px;
  width: 70%;
}
.catalog-productDescription {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 30ch;
}
.noDataAvailable-label {
  margin-left: 18px;
  margin-top: 7px;
}
.noData-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - 200px);
}
.catalog-create-div {
  margin-top: 20px;
}
.catalog-create {
  background-color: #1474a4 !important;
}
.productCatalogCardHeader {
  color: #1474a4;
  font-weight: bold;
}
.configName {
  text-decoration: underline !important;
  color: #0000ee !important;
  cursor: pointer;
}
.unsupported-browser {
  z-index: 150000 !important;
  display: inline-block;
  text-align: center;
  width: 45%;
  height: 90%;
  margin-left: auto;
  margin-right: auto;
}
.unsupported-browser .message {
  text-align: left;
  padding-top: 5px !important;
  white-space: break-spaces;
}
.unsupported-browser .unsupported-browser-image {
  height: 50;
  width: 40;
}
.unsupported-browser .versionSupported {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.unsupported-browser .versionSupported .browserBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 2%;
  justify-content: space-between;
}
.unsupported-browser .versionSupported .browserBox img {
  height: 35px;
  width: 35px;
}
.product-portfolio-container {
  display: flex;
  height: 100%;
}
.hierarchy-container {
  width: 200px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  height: calc(100% - 5.6rem);
  overflow: auto;
}
.filter-treeview > .filter-container > div > div > label > span:nth-child(2) {
  color: #1474a4 !important;
}
.filter-treeview .filter-container {
  margin-bottom: 0.7rem !important;
}
.filter-label {
  margin-right: 0px !important;
}
.filter-label > span:nth-child(2) {
  word-break: break-word !important;
}
.filter-container > .MuiTreeItem-content {
  background-color: white !important;
}
.filter-checkbox.Mui-checked ~ span {
  font-weight: bold !important;
}
.recordsPerPage {
  height: 30px;
}
.recordsPerPage > div {
  padding: 8.5px !important;
}
.error-header {
  display: flex !important;
  align-items: baseline !important;
  flex-wrap: inherit !important;
}
.errorProduct-header {
  margin-left: 10px;
}
.recordsChange-conatiner {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 10px;
}
.catalog-pagination {
  align-items: center;
  margin-top: 15px;
  position: relative;
  right: 120px;
}
.myConfig-pagination {
  align-items: center;
  margin-top: 12px;
}
.inputFieldsetWithSearchValueMatched {
  border-color: black;
  font-weight: bold;
}
.inputFieldsetWithSearchValueMatched > legend > span:nth-child(1) {
  color: #000000;
  background-color: #f3f66b;
}
.SearchValueMatched > span:nth-child(2) {
  font-weight: bold !important;
  background-color: #f3f66b;
}
.multiNumericFieldSetSearchValueMatched > legend > span:nth-child(1) {
  font-weight: bold !important;
  background-color: #f3f66b;
  color: black !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-SearchValueMatched {
  text-transform: capitalize !important;
  align-items: center;
  justify-content: left;
  text-align: left;
  min-height: 30px;
  padding: 10px;
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 800 !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-SearchValueMatched {
  color: #1474a4 !important;
  background: #c7e0f4 !important;
  font-weight: 800 !important;
}
.result-found {
  width: max-content;
  padding-top: 5px;
  margin-right: 10px;
}
.display-options-header {
  position: sticky;
  color: rgba(0, 0, 0, 0.6);
}
.add-product-action,
.disable-product-action {
  padding: 0px !important;
  width: 320px !important;
  height: 40px !important;
  margin-top: 7px !important;
  background-color: orange !important;
  color: black !important;
  text-transform: capitalize !important;
  font-size: 1rem !important;
}
.disable-product-action > span:nth-child(1) {
  margin-right: 3px !important;
}
.add-product-action > span:nth-child(1) {
  margin-right: 3px !important;
}
.add-product-action > span {
  width: max-content;
  margin-right: 2px;
}
.disable-product-action > span {
  width: max-content;
  margin-right: 2px;
}
.cart-icon {
  height: 20px !important;
  width: 20px !important;
  margin-right: 5px !important;
  position: relative !important;
  left: 6px !important;
  font-size: 25px !important;
}
.refresh-button {
  position: relative !important;
  bottom: 4px !important;
  margin-right: 10px !important;
}
.refresh-button > span {
  margin: 0px !important;
}
.Country-Label > div {
  padding: 4px !important;
}
.Country-Label > label {
  top: -7px !important;
}
.Country-Label > .MuiFormLabel-filled {
  top: 0px !important;
}
.Country-Label > .Mui-focused {
  top: 0px !important;
}
.countryCode {
  width: 100% !important;
  margin: 0px !important;
}
.countryCode .MuiOutlinedInput-root .MuiAutocomplete-endAdornment .MuiIconButton-root {
  padding: 6px;
}
.hyphen {
  color: grey;
}
.headerLogo {
  cursor: pointer !important;
}
.infoDialogIconHighlight {
  box-shadow: inset 0px 0px 1px 1px orange;
}
.preferenceDialog {
  width: 80% !important;
  height: auto !important;
  max-height: 80vh !important;
  max-width: 100% !important;
}
.inputFieldset {
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1.5px;
  border-color: rgba(0, 0, 0, 0.2);
  border-style: solid;
  width: 100% !important;
  height: fit-content;
  padding-bottom: 4px !important;
  padding-left: 0.8rem !important;
}
.inputFieldset:hover:not(:focus):not(:focus-within) {
  border-color: rgba(0, 0, 0, 0.87);
}
.inputFieldset:focus-within {
  border-color: #1173a3;
}
.inputFieldset > legend.inputLegend {
  color: rgba(0, 0, 0, 0.6);
  word-break: break-all;
  display: flex;
}
.inputFieldset:focus-within > legend.inputLegend {
  color: #1474a4;
}
.inputFieldset:hover:not(:focus):not(:focus-within) > legend.inputLegend {
  color: rgba(0, 0, 0, 0.87);
}
.preference-container,
.logout-container {
  cursor: pointer;
}
.radio-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.margin-default {
  margin-left: 16px !important;
}
.popperPage {
  position: relative !important;
  right: 10px !important;
  width: 135px !important;
}
.messagesTable th,
tr > td {
  font-size: small !important;
}
.invalidCurrency {
  color: red !important;
}
.baseModelName {
  color: #1474a4 !important;
  font-size: 0.975rem !important;
  border-bottom: none !important;
  width: 65% !important;
  padding-left: 5px !important;
}
.baseModelPriceCell {
  padding-left: 5px !important;
  font-size: 1rem !important;
  text-align: right !important;
  border-bottom: none !important;
  word-break: break-all;
  width: 45%;
}
.table-cell-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60ch !important;
  display: table-cell !important;
}
.table-cell-overflow-mobile {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60ch !important;
  display: table-cell !important;
}
.icon-font-size svg {
  font-size: 1.6rem !important;
  margin: 0 0.5px;
}
.search-icon {
  margin-left: 0px !important;
}
.search-icon svg {
  font-size: 1.6rem !important;
  margin: 0 0.5px;
}
.rest-icon {
  width: 22px;
  height: 22px;
  margin: 0 0.5px;
}
.nonce-1k33q06 {
  font-size: 1.3rem !important;
  margin: 0 0.5px;
}
.disclaimer {
  word-wrap: break-word;
  font-weight: bold;
  padding: 0;
}
.disclaimer p {
  padding-top: 3px;
  margin: 0px;
}
.disclaimer-addproduct {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.summary-view {
  height: 100%;
}
.summary-view .add-product-btn {
  width: 100%;
  margin: auto;
  text-align: center;
}
.crumb-font-size {
  font-size: 1.1rem !important;
  margin: 0 0.5px;
}
.tree-group {
  display: flex;
}
.filter-button {
  position: absolute !important;
  right: 0px;
  top: -3px;
}
.nonce-8ver8g-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input,
.nonce-1mijcsb-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 0px !important;
}
.collapsed {
  margin: 0px 0px 0px 15px !important;
}
.collapsed .Mui-disabled.MuiInputBase-fullWidth.MuiInputBase-formControl {
  padding: 0px !important;
}
.collapsed .Mui-disabled.MuiInputBase-fullWidth.MuiInputBase-formControl .MuiChip-sizeMedium.MuiChip-colorDefault.MuiChip-deletable {
  padding-left: 3px;
  font-size: 13px;
}
.collapsed .Mui-disabled.MuiInputBase-fullWidth.MuiInputBase-formControl .MuiChip-sizeMedium.MuiChip-colorDefault.MuiChip-deletable span {
  padding: 0px;
  padding-right: 7px;
}
.collapsed .Mui-disabled.MuiInputBase-fullWidth.MuiInputBase-formControl .MuiChip-sizeMedium.MuiChip-colorDefault.MuiChip-deletable svg {
  font-size: 14px;
}
.loader-placeholder {
  text-align: center;
}
/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
  .create-configuration-dialog .MuiDialog-container .MuiPaper-root {
    width: 100%;
    max-width: 50%;
    height: auto !important;
    max-height: 65%;
  }
}
/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .create-configuration-dialog .MuiDialog-container .MuiPaper-root {
    width: 100%;
    max-width: 50%;
    height: auto !important;
    max-height: 65%;
  }
}
/* 
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
  .create-configuration-dialog .MuiDialog-container .MuiPaper-root {
    width: 100%;
    max-width: 55%;
    height: auto !important;
    max-height: 65%;
  }
}
/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/
@media (min-width: 320px) and (max-width: 480px) {
  .create-configuration-dialog .MuiDialog-container .MuiPaper-root {
    width: 100%;
    max-width: 60%;
    height: auto !important;
    max-height: 65%;
  }
}
.headerLogoButton {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}
.dynamic-input-tooltip {
  margin-left: 2.5em !important;
}
.warningIcon {
  color: #f7d368;
}
.warning-icon-box {
  margin-right: 4px;
  display: inline-flex;
}
.assignment-section {
  margin-top: 2vh;
}
`, "",{"version":3,"sources":["webpack://./style/index.less"],"names":[],"mappings":"AAAA;;;EAqNE,aAAA;EA4BA,sBAAA;EAgSA,WAAA;EACA,YAAA;EAxLA,SAAA;EAyBA,UAAA;EA3WA,gBAAA;AAEF;AADE;;;EACE,gBAAA;AAKJ;AADA;EACE,oEAAA;EACA,gBAAA;AAGF;AAAA;EACE,oEAAA;AAEF;AACA;EACE,sBAAA;AACF;AAEA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;AAAF;AAWA;EACE,UAAA;EACA,WAAA;AATF;AAYA;EACE,mBAAA;AAVF;AAaA;EACE,mBAAA;AAXF;AAcA;EACE,mBAAA;AAZF;AAgBA;EACE,8BAAA;EACA,kBAAA;EACA,yBAAA;AAdF;AAgBE;EACE,+BAAA;AAdJ;AAkBA;EACE,qBAAA;AAhBF;AAoBA;EACE,2BAAA;AAlBF;AAmBE;;EAEE,wBAAA;EACA,SAAA;AAjBJ;AAqBA;;EAEE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AAnBF;AAUA;;;;EAaI,eAAA;AAjBJ;AAoBE;;EACE,yBAAA;EACA,qBAAA;EACA,aAAA;AAjBJ;AAoBE;;EACE,qBAAA;AAjBJ;AAoBE;;EACE,cAAA;AAjBJ;AAoBE;;EACE,iCAAA;AAjBJ;AAoBE;;EACE,0BAAA;AAjBJ;AAqBA;EACE,sBAAA;AAnBF;AAsBA;EACE,UAAA;EACA,uBAAA;AApBF;AAuBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AArBF;AAwBA;EACE,wBAAA;EACA,8BAAA;AAtBF;AAyBA;EACE,2BAAA;EACA,mBAAA;EACA,uBAAA;AAvBF;AA0BA;EACE,0BAAA;EACA,mCAAA;EACA,iCAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBAAA;EACA,oBAAA;AAxBF;AA2BA;EACE,mBAAA;EACA,4CAAA;AAzBF;AA4BA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EAEA,kBAAA;EACA,mBAAA;AA3BF;AA8BA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AA5BF;AA+BA;EACE,4BAAA;AA7BF;AAgCA;EACE,yBAAA;AA9BF;AAiCA;EACE,yBAAA;AA/BF;AAkCA;EACE,wBAAA;AAhCF;AAmCA;EACE,uBAAA;AAjCF;AAwCA;EACE,aAAA;AAtCF;AAyCA;EACE,oBAAA;AAvCF;AA0CA;EACE,cAAA;AAxCF;AA2CA;EACE,wBAAA;AAzCF;AA4CA;EACE,qBAAA;AA1CF;AA6CA;EACE,eAAA;AA3CF;AA8CA;EACE,mBAAA;AA5CF;AA+CA;EACE,sBAAA;AA7CF;AAgDA;EACE,iBAAA;AA9CF;AAiDA;EACE,WAAA;EACA,YAAA;AA/CF;AAkDA;EACE,SAAA;AAhDF;AAmDA;EACE,UAAA;AAjDF;AAoDA;EACE,UAAA;AAlDF;AAqDA;EACE,sBAAA;AAnDF;AAsDA;EACE,WAAA;AApDF;AAuDA;EACE,aAAA;AArDF;AAwDA;EACE,UAAA;AAtDF;AAyDA;EACE,UAAA;AAvDF;AA0DA;EACE,UAAA;AAxDF;AA2DA;EACE,UAAA;AAzDF;AA4DA;EACE,UAAA;AA1DF;AA6DA;EACE,UAAA;AA3DF;AA8DA;EACE,aAAA;AA5DF;AA+DA;EACE,cAAA;AA7DF;AAgEA;EACE,cAAA;AA9DF;AAiEA;EACE,eAAA;AA/DF;AAkEA;EACE,cAAA;AAhEF;AAmEA;EACE,gBAAA;AAjEF;AAoEA;EACE,UAAA;AAlEF;AAqEA;EACE,WAAA;AAnEF;AAsEA;EACE,WAAA;AApEF;AAuEA;EACE,YAAA;AArEF;AAwEA;EACE,YAAA;AAtEF;AAyEA;EACE,SAAA;AAvEF;AA0EA;EACE,aAAA;AAxEF;AA2EA;EACE,eAAA;AAzEF;AA4EA;EACE,gBAAA;AA1EF;AA6EA;EACE,cAAA;AA3EF;AA8EA;EACE,iBAAA;EACA,kBAAA;AA5EF;AA+EA;EACE,UAAA;AA7EF;AAgFA;EACE,YAAA;AA9EF;AAiFA;EACE,aAAA;AA/EF;AAkFA;EACE,aAAA;AAhFF;AAkFA;EACE,aAAA;AAhFF;AAmFA;EACE,aAAA;AAjFF;AAoFA;EACE,yBAAA;AAlFF;AAqFA;EACE,2BAAA;AAnFF;AAqFA;EACE,4BAAA;AAnFF;AAsFA;EACE,eAAA;AApFF;AAuFA;EACE,gBAAA;AArFF;AAwFA;EACE,4BAAA;AAtFF;AAyFA;EAtBE,yBAAA;EAmBA,4BAAA;AAlFF;AA0FA;EAZE,gBAAA;EAJA,eAAA;AAtEF;AA2FA;EACE,cAAA;AAzFF;AA4FA;EACE,gBAAA;AA1FF;AA6FA;EACE,gBAAA;AA3FF;AA8FA;EACE,gBAAA;AA5FF;AA+FA;EACE,4BAAA;AA7FF;AAgGA;EACE,kBAAA;AA9FF;AAiGA;EACE,qCAAA;AA/FF;AAkGA;EACE,iBAAA;AAhGF;AAmGA;EACE,8BAAA;AAjGF;AAoGA;EACE,sBAAA;AAlGF;AAqGA;EACE,uBAAA;AAnGF;AAsGA;EACE,mBAAA;AApGF;AAuGA;EACE,6BAAA;AArGF;AAwGA;EACE,kBAAA;AAtGF;AAyGA;EACE,sBAAA;AAvGF;AA0GA;EACE,qBAAA;AAxGF;AA2GA;EACE,uBAAA;AAzGF;AA4GA;EACE,sBAAA;AA1GF;AA6GA;EACE,8BAAA;AA3GF;AA8GA;EACE,2BAAA;AA5GF;AA+GA;EACE,YAAA;AA7GF;AAgHA;EACE,yBAAA;AA9GF;AAiHA;EACE,oBAAA;AA/GF;AAkHA;EAjTE,aAAA;EAwBA,mBAAA;AA2KF;AAmHA;EAtTE,aAAA;EA4BA,sBAAA;AA2KF;AAoHA;EACE,WAAA;EACA,YAAA;AAlHF;AAqHA;EACE,2BAAA;EACA,uBAAA;AAnHF;AAsHA;EACE,eAAA;AApHF;AAuHA;EACE,kBAAA;AArHF;AAwHA;EACE,uBAAA;AAtHF;AAyHA;EACE,YAAA;AAvHF;AA0HA;EACE,2BAAA;AAxHF;AA2HA;EACE,yBAAA;AAzHF;AA4HA;EACE,2BAAA;AA1HF;AA6HA;EACE,yBAAA;AA3HF;AA8HA;EACE,wBAAA;AA5HF;AA+HA;EACE,SAAA;AA7HF;AAgIA;EACE,cAAA;AA9HF;AAiIA;EACE,eAAA;EACA,wBAAA;AA/HF;AAkIA;EAEI,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,+CAAA;EACA,YAAA;AAjIJ;AA2HA;EAUI,mBAAA;EACA,4CAAA;AAlIJ;AAuHA;EAeI,4BAAA;AAnIJ;AAoHA;EAtXE,aAAA;EAkQA,mBAAA;EAgBA,qBAAA;EAlPA,iBAAA;EA6WE,eAAA;EACA,mCAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;AApIJ;AAyGA;EA+BI,4BAAA;EACA,4BAAA;EACA,qBAAA;EACA,qBAAA;AArIJ;AAmGA;EAhIE,8BAAA;EAuKE,4BAAA;EACA,4BAAA;EACA,4BAAA;AAtIJ;AA6FA;EA6CI,6BAAA;EACA,qBAAA;EACA,qBAAA;AAvIJ;AAwFA;EAmDI,wCAAA;AAxIJ;AAqFA;EAuDI,iCAAA;AAzIJ;AAkFA;EA2DI,UAAA;EACA,YAAA;AA1IJ;AA8EA;EAgEI,kBAAA;EACA,qBAAA;AA3IJ;AA0EA;EAqEI,YAAA;AA5IJ;AAuEA;EAtXE,aAAA;EAkQA,mBAAA;EAgBA,qBAAA;EAhDA,gBAAA;EAwBA,sBAAA;EA0ME,eAAA;AA7IJ;AA+DA;EAtXE,aAAA;EAkQA,mBAAA;EAgBA,qBAAA;EAhDA,gBAAA;EAwBA,sBAAA;EA0ME,eAAA;EA9MF,8BAAA;AA0EF;AAsDA;EA5EE,yBAAA;EAtSA,oBAAA;EAqGA,cAAA;EAyJA,mBAAA;EARA,sBAAA;EA4BA,uBAAA;EA6LE,eAAA;AA1IJ;AA8II;EAzKF,oBAAA;AA8BF;AA0CA;EAuGI,YAAA;AA9IJ;AAuCA;EA2GI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AA/IJ;AAiCA;EAtXE,aAAA;EAkQA,mBAAA;EAwOE,gBAAA;AAhJJ;AA4BA;EAwHI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAjJJ;AAmBA;EAkII,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,WAAA;EACA,2BAAA;AAlJJ;AAYA;EA0II,eAAA;EACA,yBAAA;AAnJJ;AAQA;EA+II,WAAA;EACA,gBAAA;EACA,2DAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AApJJ;AADA;EAyJI,WAAA;EACA,gBAAA;EACA,2DAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AArJJ;AAVA;EAmKI,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAtJJ;AAjBA;EA2KI,4BAAA;EACA,2DAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAvJJ;AAxBA;EAmLI,4BAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAxJJ;AA4JI;EACE,qCAAA;AA1JN;AA6JI;EACE,qCAAA;AA3JN;AAgKA;EAEI,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,+CAAA;EACA,YAAA;AA/JJ;AAyJA;EAUI,mBAAA;EACA,4CAAA;AAhKJ;AAqJA;EAcM,aAAA;EACA,mBAAA;AAhKN;AAiJA;EAkBQ,SAAA;AAhKR;AA8IA;EAqBU,mBAAA;EACA,0BAAA;AAhKV;AA0IA;EA4BM,aAAA;EACA,QAAA;EACA,mBAAA;AAnKN;AAqIA;EAmCI,gBAAA;EACA,UAAA;EACA,YAAA;AArKJ;AAgIA;EA1jBE,aAAA;EAkQA,mBAAA;EAgBA,qBAAA;EAhDA,gBAAA;EAwBA,sBAAA;EA6WE,eAAA;AArKJ;AAwHA;EA1jBE,aAAA;EAkQA,mBAAA;EAgBA,qBAAA;EAhDA,gBAAA;EAwBA,sBAAA;EA6WE,eAAA;EAjXF,8BAAA;AAqNF;AA+GA;EA1jBE,aAAA;EAkQA,mBAAA;EAgBA,qBAAA;EAlPA,iBAAA;EAmlBE,eAAA;EACA,mCAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,cAAA;AAjKJ;AAmGA;EAiEI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAjKJ;AA6FA;EAwEI,eAAA;EACA,yBAAA;AAlKJ;AAyFA;EA4EM,mBAAA;EACA,WAAA;AAlKN;AAqFA;EAkFI,gCAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AApKJ;AAsKI;EACE,kBAAA;AApKN;AAuKI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AArKN;AAwKI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAtKN;AAyKI;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAvKN;AAiDA;EA2HI,yBAAA;EACA,gBAAA;EACA,gCAAA;EACA,+BAAA;AAzKJ;AA2KI;EACE,kBAAA;AAzKN;AA8KI;EACE,qCAAA;AA5KN;AA+KI;EACE,qCAAA;AA7KN;AAkCA;EAgJI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AA/KJ;AA4BA;EAuJI,iBAAA;EACA,gBAAA;EACA,kBAAA;AAhLJ;AAuBA;EA2JM,eAAA;EACA,aAAA;AA/KN;AAmBA;EA+JQ,mBAAA;EACA,WAAA;AA/KR;AAeA;EAsKI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAlLJ;AASA;EA4KM,wBAAA;EACA,cAAA;EACA,eAAA;AAlLN;AAIA;EAmLI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AApLJ;AALA;EA6LI,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,WAAA;EACA,2BAAA;AArLJ;AAZA;EAqMI,yBAAA;EACA,4BAAA;AAtLJ;AAhBA;EA0MI,eAAA;EACA,yBAAA;AAvLJ;AApBA;EA+MI,WAAA;EACA,gBAAA;EACA,2DAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAxLJ;AA7BA;EAyNI,WAAA;EACA,gBAAA;EACA,2DAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAzLJ;AAtCA;EAmOI,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AA1LJ;AA7CA;EA2OI,4BAAA;EACA,2DAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AA3LJ;AArDA;EAoPI,4BAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AA5LJ;AAgMA;EACE,8BAAA;AA9LF;AA+LE;EAvzBA,aAAA;EA4BA,sBAAA;EAqSA,2BAAA;EACA,uBAAA;EANA,WAAA;EACA,YAAA;AAmUF;AAqLA;EArzBE,aAAA;EAwBA,mBAAA;EAySA,2BAAA;EACA,uBAAA;EANA,WAAA;EACA,YAAA;EAogBE,eAAA;EACA,uBAAA;AAxLJ;AA2KA;EArzBE,aAAA;EAwBA,mBAAA;EAySA,2BAAA;EACA,uBAAA;EANA,WAAA;EACA,YAAA;EA4gBE,eAAA;EACA,sBAAA;AAtLJ;AAiKA;EArzBE,aAAA;EAwBA,mBAAA;EAySA,2BAAA;EACA,uBAAA;EANA,WAAA;EACA,YAAA;EAohBE,eAAA;EACA,wBAAA;AApLJ;AAyLE;EAv1BA,aAAA;EA4BA,sBAAA;EAqSA,2BAAA;EACA,uBAAA;EANA,WAAA;EACA,YAAA;EAvGA,cAAA;EAsoBE,cAAA;AApLJ;AAuLE;EAEE,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,2CAAA;EACA,sBAAA;AAtLJ;AAuKA;EAmBI,sBAAA;AAvLJ;AA2LI;EACE,gBAAA;AAzLN;AA4LI;EACE,mBAAA;AA1LN;AA8JA;EAiCI,gBAAA;AA5LJ;AA+LE;EAEI,sBAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;AA9LN;AAyLE;EASI,UAAA;EACA,kBAAA;EACA,mBAAA;AA/LN;AAoLE;EAeI,UAAA;EACA,mBAAA;EACA,uBAAA;AAhMN;AA2IA;;EA4DM,uBAAA;EACA,gBAAA;EACA,mBAAA;AAnMN;AAqIA;EAkEM,iBAAA;AApMN;AAuMI;EAGM,qBAAA;EACA,sBAAA;EACA,oBAAA;AAvMV;AAwMU;EACE,eAAA;EACA,YAAA;EACA,UAAA;AAtMZ;AA6LI;EAaM,aAAA;AAvMV;AA0LI;;EAkBI,qBAAA;EACA,sBAAA;EACA,oBAAA;AAxMR;AA8MA;EAEI,mBAAA;EACA,+CAAA;EACA,YAAA;EACA,2BAAA;AA7MJ;AAwMA;EASI,mBAAA;EACA,4CAAA;AA9MJ;AAoMA;EAcI,UAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;AA/MJ;AA2LA;EAwBI,4BAAA;EACA,4BAAA;AAhNJ;AAuLA;EA6BI,4BAAA;EACA,qBAAA;EACA,qBAAA;AAjNJ;AAkLA;EA6BI,4BAAA;EACA,qBAAA;EACA,qBAAA;EAKA,4BAAA;AAhNJ;AA4KA;EA6BI,4BAAA;EACA,qBAAA;EACA,qBAAA;EAUA,qBAAA;AA/MJ;AAsKA;EA6CI,4BAAA;EACA,4BAAA;AAhNJ;AAkKA;EAkDI,0BAAA;AAjNJ;AA+JA;EAsDI,qBAAA;EACA,uBAAA;AAlNJ;AA2JA;EAvtBE,gBAAA;EArEA,iBAAA;EACA,kBAAA;EAw1BE,YAAA;AAlNJ;AAsNI;EAxsBF,oBAAA;AAqfF;AAkJA;EA/tBE,cAAA;EA7DA,iBAAA;EACA,kBAAA;EAo2BE,YAAA;AArNJ;AA4IA;EA6EI,wBAAA;EACA,iCAAA;AAtNJ;AAwIA;EAiFM,eAAA;EACA,0BAAA;EACA,mBAAA;AAtNN;AAmIA;EAuFM,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAvNN;AAyNM;EACE,yBAAA;AAvNR;AAwHA;EAqGI,iBAAA;EACA,YAAA;AA1NJ;AA+NE;EAhiCA,aAAA;EAkiCE,WAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AA7NJ;AAqNA;EAYI,iBAAA;EACA,kBAAA;AA9NJ;AAiNA;EA/hCE,aAAA;EAwBA,mBAAA;EA0hCE,iBAAA;AA/NJ;AAkOE;EACE,yBAAA;AAhOJ;AAmOE;EACE,yBAAA;AAjOJ;AAoOE;EACE,yBAAA;AAlOJ;AAqOE;EACE,yBAAA;AAnOJ;AAuOA;EAEI,UAAA;EACA,gBAAA;EACA,gBAAA;AAtOJ;AA0OA;EA9kCE,aAAA;EAwBA,mBAAA;EAyjCA,iBAAA;AAxOF;AAqOA;EAxwBE,eAAA;EA+wBE,0BAAA;EACA,WAAA;AAxOJ;AA4OA;EACE,iBAAA;AA1OF;AA6OA;EACE,mCAAA;AA3OF;AA8OA;EA5xBE,eAAA;EA8xBA,uBAAA;EAl8BA,uBAAA;AAutBF;AAyOA;EAMI,YAAA;EACA,WAAA;AA5OJ;AAiPE;EACE,UAAA;EACA,WAAA;AA/OJ;AAkPE;EACE,WAAA;EACA,YAAA;EA7mCF,cAAA;EAiCA,SAAA;EA+kCE,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,mBAAA;AAhPJ;AAoPA;EACE,yBAAA;EAtyBA,oCAAA;AAqjBF;AAqPA;EA//BE,oBAAA;EAigCA,uBAAA;AAnPF;AAsPA;EACE,uBAAA;AApPF;AAuPA;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,0BAAA;AArPF;AAuPA;EACE,yBAAA;AArPF;AAwPA;EACE,2BAAA;EACA,kBAAA;AAtPF;AAyPA;EACE,qBAAA;AAvPF;AA0PA;EACE,UAAA;AAxPF;AA2PA;EACE,YAAA;EACA,iBAAA;AAzPF;AA4PA;EACE,cAAA;AA1PF;AA6PA;EACE,eAAA;AA3PF;AA8PA;EACE,cAAA;AA5PF;AA+PA;EACE,cAAA;AA7PF;AAgQA;EACE,cAAA;EACA,gBAAA;AA9PF;AAiQA;EACE,YAAA;AA/PF;AAkQA;EAr9BE,qCAAA;EAoBA,mBAAA;EAgBA,qBAAA;EAhDA,gBAAA;EAs+BA,gBAAA;EACA,aAAA;EACA,qCAAA;AAhQF;AAoQE;EA9sCA,aAAA;EAwBA,mBAAA;EAySA,2BAAA;EACA,uBAAA;AA8oBF;AA6PA;EA7sCE,aAAA;EAwBA,mBAAA;EA6rCE,8BAAA;EACA,mBAAA;EA15BF,WAAA;EACA,YAAA;EA25BE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;AA/PJ;AAiPA;EA7sCE,aAAA;EAwBA,mBAAA;EAwsCE,2BAAA;EACA,mBAAA;AA/PJ;AA2OA;EAwBI,SAAA;AAhQJ;AAwOA;EAv4BE,eAAA;EAo6BE,cAAA;AAjQJ;AAoOA;EA7sCE,aAAA;EA4BA,sBAAA;EAotCE,gBAAA;EACA,cAAA;AAlQJ;AA8NA;EAwCI,kBAAA;AAnQJ;AAqQM;EAEI,yBAAA;AApQV;AAkQM;EAKI,yBAAA;AApQV;AAqNA;EAsDI,uBAAA;EACA,qBAAA;EACA,cAAA;AAxQJ;AA4QA;EAEI,mBAAA;AA3QJ;AAyQA;EAMI,wBAAA;EACA,uBAAA;AA5QJ;AAqQA;EAWI,gBAAA;AA7QJ;AAkQA;EAeI,yBAAA;EACA,YAAA;AA9QJ;AAkRA;EAEI,kBAAA;AAjRJ;AAqRA;EA9pCE,SAAA;EAiqCE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AApRJ;AAuRE;;EAEE,mBAAA;AArRJ;AAyRA;EAEI,qBAAA;EACA,uBAAA;EACA,0BAAA;AAxRJ;AAoRA;EAQI,WAAA;EACA,wBAAA;EACA,8BAAA;AAzRJ;AA+QA;EAcI,2BAAA;EACA,mBAAA;EACA,uBAAA;AA1RJ;AA0QA;EAhjCE,mBAAA;EAjIA,YAAA;AA26BF;AAsQA;EAyBI,UAAA;AA5RJ;AAmQA;EA6BI,wBAAA;EACA,iCAAA;AA7RJ;AA+PA;EAkCI,eAAA;EAtmCF,qCAAA;EAtNA,mBAAA;AAgiCF;AA0PA;EAwCI,aAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EArsCF,iBAAA;EACA,kBAAA;AAu6BF;AA+RI;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AA7RN;AA8RM;EACE,6BAAA;EACA,gBAAA;AA5RR;AA+RQ;EACE,eAAA;AA7RV;AA+RQ;EACE,cAAA;EA5nCR,iBAAA;EA8nCQ,oBAAA;EACA,8BAAA;EACA,sBAAA;AA7RV;AA8RU;EACE,YAAA;EACA,mBAAA;AA5RZ;AAuQI;EA2BI,eAAA;AA/RR;AAoQI;EA+BI,eAAA;AAhSR;AAmNA;EAmFI,WAAA;AAnSJ;AAgNA;EAuFI,uBAAA;EACA,aAAA;AApSJ;AA4MA;EA4FI,8BAAA;AArSJ;AAwSA;EAEI,UAAA;AAvSJ;AA2SA;EA7jCE,yBAAA;EAgkCE,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,YAAA;AA1SJ;AAoSA;EAUI,YAAA;AA3SJ;AAiSA;EA7kCE,kBAAA;EA4lCE,UAAA;EACA,QAAA;EACA,WAAA;AA5SJ;AA2RA;EAqBI,mBAAA;EACA,4CAAA;AA7SJ;AAiTA;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;AA/SF;AAkTA;EACE,eAAA;EACA,2BAAA;EACA,UAAA;AAhTF;AAoTE;EAr8CA,aAAA;EA4BA,sBAAA;EAsQA,2BAAA;EAhCA,mBAAA;EAwsCE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AAlTJ;AAoTE;EAr9CA,aAAA;EA4BA,sBAAA;EAsQA,2BAAA;EAhCA,mBAAA;EAwsCE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EAIA,sBAAA;AArSJ;AAwSE;EA19CA,aAAA;EA4BA,sBAAA;EAsQA,2BAAA;EAhCA,mBAAA;EAwsCE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EASA,sBAAA;AAzRJ;AA4RE;EACE,wBAAA;AA1RJ;AA8PA;EAgCI,uBAAA;AA3RJ;AA8RE;;EAEE,YAAA;EAh8CF,SAAA;EAqHA,UAAA;EA80CE,gBAAA;AA5RJ;AAoPA;EA/zCE,SAAA;AA8kCF;AAgSE;EAzqCA,kBAAA;EA2qCE,QAAA;EACA,SAAA;EACA,iCAAA;EACA,WAAA;EACA,aAAA;AA9RJ;AAyOA;EA/4CE,sBAAA;EA+8CE,eAAA;AArSJ;AAqOA;EAp8CE,aAAA;EAwBA,mBAAA;EAu+CI,6BAAA;EACA,mBAAA;AA3RN;AA+NA;EAoEI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,4CAAA;AAhSJ;AAwNA;EA4EI,iBAAA;EACA,eAAA;EACA,yCAAA;AAjSJ;AAmNA;EAkFI,cAAA;EA5sCF,kBAAA;EA5KA,UAAA;EAgHA,sBAAA;AAy+BF;AA6MA;EAyFI,kBAAA;AAnSJ;AAsSE;EACE,SAAA;AApSJ;AAuSE;EACE,YAAA;AArSJ;AAoMA;EA1nCE,kBAAA;EA5KA,UAAA;EA44CE,oBAAA;AArSJ;AA0SE;EA/iDA,aAAA;EA4BA,sBAAA;EAqSA,2BAAA;EACA,uBAAA;EANA,WAAA;EACA,YAAA;EAsvCE,UAAA;AArSJ;AAgSA;EA9iDE,aAAA;EAwBA,mBAAA;EAsQA,8BAAA;EA5BA,mBAAA;EAyzCE,WAAA;AAtSJ;AAyRA;EA9iDE,aAAA;EAwBA,mBAAA;EAsQA,8BAAA;EA8BA,WAAA;EACA,YAAA;EAswCE,gBAAA;AAtSJ;AAiRA;EAyBI,WAAA;AAvSJ;AA2SA;EACE,yBAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;AAzSF;AA6SE;EAnlDA,aAAA;EAwBA,mBAAA;EA0QA,2BAAA;EAhCA,mBAAA;EAs1CE,WAAA;EACA,eAAA;AA3SJ;AAoSA;EAWI,sBAAA;AA5SJ;AAiSA;EApuCE,cAAA;EAovCE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AA7SJ;AAuRA;EA0BI,iBAAA;AA9SJ;AAkTA;EAEI,cAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;AAjTJ;AA4SA;EASI,kBAAA;EACA,qBAAA;AAlTJ;AAwSA;EAcI,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,+CAAA;EACA,YAAA;AAnTJ;AAiSA;EAsBI,mBAAA;EACA,yCAAA;AApTJ;AA6RA;EA2BI,4BAAA;EACA,gBAAA;AArTJ;AA0TE;EAjpDA,aAAA;EA4BA,sBAAA;EAqSA,2BAAA;EACA,uBAAA;EAk1CE,WAAA;EACA,aAAA;AAtTJ;AAiTA;EAhpDE,aAAA;EAwBA,mBAAA;EAySA,2BAAA;EACA,uBAAA;EAy1CE,WAAA;AArTJ;AA0SA;EAeI,WAAA;EACA,gBAAA;AAtTJ;AAsSA;EAoBI,UAAA;EACA,YAAA;EACA,qBAAA;AAvTJ;AAiSA;EA0BI,YAAA;AAxTJ;AA8RA;EA8BI,gCAAA;AAzTJ;AA2RA;EAlyCE,yBAAA;EAq0CE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AA1TJ;AAoRA;EA0CI,0BAAA;AA3TJ;AAgUE;EACE,gBAAA;EACA,WAAA;AA9TJ;AAiUE;;EAEE,WAAA;EACA,mBAAA;AA/TJ;AAsTA;EAaI,eAAA;EACA,WAAA;AAhUJ;AAkTA;EAkBI,oBAAA;EACA,iBAAA;AAjUJ;AA8SA;EAuBI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;AAlUJ;AAwSA;EA8BI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAnUJ;AAgSA;EAqCM,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlUN;AAmUM;EACE,aAAA;AAjUR;AAwRA;EA+CI,oBAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AApUJ;AA+QA;EAyDI,aAAA;EACA,UAAA;AArUJ;AA2QA;EA8DI,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;AAtUJ;AAgQA;EA0EI,mBAAA;EACA,6BAAA;AAvUJ;AA4PA;EA+EI,UAAA;EApnDF,iBAAA;EACA,kBAAA;AA6yCF;AA0UA;EAEI,oBAAA;EACA,4BAAA;EACA,eAAA;AAzUJ;AAqUA;EAQI,4BAAA;AA1UJ;AA8UA;EACE,gBAAA;AA5UF;AA2UA;EAII,qDAAA;AA5UJ;AAgVA;EA/7CE,wBAAA;AAknCF;AAmVA;EAz8CE,yBAAA;AAynCF;AAsVA;EAjzDE,aAAA;EA4BA,sBAAA;AAm8CF;AAuVA;EACE,yBAAA;EACA,6BAAA;EACA,qBAAA;EAqcA,4BAAA;EACA,6BAAA;AAzxBF;AAuVA;EACE,gDAAA;AArVF;AAwVA;EACE,cAAA;AAtVF;AAyVA;EACE,cAAA;EACA,kBAAA;EACA,QAAA;AAvVF;AA0VA;EACE,YAAA;EACA,iBAAA;EACA,UAAA;AAxVF;AA2VA;EACE,iBAAA;EACA,UAAA;AAzVF;AA4VA;EACE,oBAAA;AA1VF;AA6VA;EACE,8BAAA;AA3VF;AA8VA;EACE,uBAAA;EACA,WAAA;AA5VF;AA+VA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AA7VF;AAgWA;EACE,UAAA;EACA,cAAA;EACA,0BAAA;EACA,cAAA;AA9VF;AAiWA;EACE,0BAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AA/VF;AAkWA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,2BAAA;AAhWF;AA4VA;EAMI,aAAA;EACA,mBAAA;EACA,2BAAA;AA/VJ;AAmWA;EACE,cAAA;EACA,UAAA;EACA,cAAA;AAjWF;AAoWA;EACE,YAAA;AAlWF;AAqWA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAnWF;AAsWA;EACE,2BAAA;AApWF;AAuWA;EACE,yBAAA;EACA,qCAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AArWF;AAwWA;EACE,mBAAA;AAtWF;AAqWA;EAII,eAAA;EACA,YAAA;AAtWJ;AA0WA;EACE,YAAA;AAxWF;AA2WA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,mBAAA;AA1WF;AAoWA;EASI,2BAAA;EACA,8BAAA;AA1WJ;AAgWA;EAeI,8BAAA;AA5WJ;AAgXA;EACE,sBAAA;AA9WF;AAiXA;EAEI,WAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AAhXJ;AA2WA;EASI,kBAAA;AAjXJ;AAwWA;EAaI,iBAAA;EACA,2BAAA;EACA,wBAAA;AAlXJ;AAmWA;EAmBI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,mBAAA;EACA,oBAAA;AAnXJ;AAyVA;EA6BM,mBAAA;AAnXN;AAwXA;EACE,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,+CAAA;EACA,YAAA;AAtXF;AAyXA;EACE,6BAAA;EACA,2BAAA;AAvXF;AA0XA;EAEI,qBAAA;EACA,wBAAA;EACA,0BAAA;AAzXJ;AAqXA;EAQI,WAAA;EACA,wBAAA;EACA,8BAAA;AA1XJ;AAgXA;EAcI,2BAAA;EACA,mBAAA;EACA,uBAAA;AA3XJ;AA2WA;EAp3DE,YAAA;EAy4DE,kBAAA;AA5XJ;AAuWA;EAyBI,qBAAA;AA7XJ;AAoWA;EA6BI,aAAA;EACA,8BAAA;EACA,YAAA;AA9XJ;AA+VA;;EAoCI,+BAAA;EACA,UAAA;AA/XJ;AA0VA;;EAwCM,gBAAA;AA9XN;AAsVA;;EA4CM,cAAA;AA9XN;AAkVA;;EAgDM,cAAA;AA9XN;AA8UA;;EAoDM,cAAA;AA9XN;AA0UA;;EAwDM,WAAA;EACA,eAAA;EACA,gBAAA;AA9XN;AAoUA;;EA8DM,sBAAA;EACA,sBAAA;AA9XN;AA+TA;;EAkEQ,0BAAA;EACA,6BAAA;AA7XR;AA0TA;;EAwEQ,8BAAA;AA9XR;AAsTA;EA8EI,gBAAA;AAjYJ;AAmTA;EAkFI,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAlYJ;AA4SA;EAyFM,gBAAA;EACA,MAAA;AAlYN;AAwSA;EA8FM,wBAAA;AAnYN;AAqSA;EAkGM,aAAA;EACA,yBAAA;EACA,WAAA;EAEA,kBAAA;EACA,qBAAA;EACA,uDAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AArYN;AAoRA;EAqHM,kBAAA;EACA,mBAAA;EACA,SAAA;AAtYN;AA+QA;EA2HM,eAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;AAvYN;AAmQA;EAsIQ,sBAAA;AAtYR;AAgQA;EA2IM,iBAAA;AAxYN;AA6PA;EAgJI,wBAAA;EACA,iCAAA;AA1YJ;AAyPA;EAqJI,aAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EAr/DF,iBAAA;EACA,kBAAA;AA2mDF;AA2YI;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAzYN;AA0YM;EACE,6BAAA;EACA,gBAAA;AAxYR;AA2YQ;EACE,eAAA;AAzYV;AA2YQ;EACE,cAAA;EA56DR,iBAAA;EA86DQ,oBAAA;EACA,8BAAA;EACA,sBAAA;AAzYV;AA0YU;EACE,YAAA;EACA,mBAAA;AAxYZ;AAmXI;EA2BI,eAAA;AA3YR;AAgXI;EA+BI,eAAA;AA5YR;AAkZA;EACE,2BAAA;EACA,8BAAA;AAhZF;AA8YA;EAII,8BAAA;AA/YJ;AAmZA;EAEI,YAAA;EACA,WAAA;AAlZJ;AA+YA;EAOI,SAAA;EACA,eAAA;EACA,2BAAA;AAnZJ;AA0YA;EAaI,SAAA;EACA,gBAAA;EACA,2BAAA;AApZJ;AAqYA;EAmBI,UAAA;EACA,gBAAA;EACA,2BAAA;AArZJ;AAgYA;EAyBI,UAAA;EACA,gBAAA;EACA,2BAAA;AAtZJ;AA2XA;EA8BI,SAAA;EACA,gBAAA;EACA,2BAAA;AAtZJ;AAsXA;EAoCI,UAAA;EACA,gBAAA;EACA,2BAAA;AAvZJ;AAiXA;EA0CI,2BAAA;AAxZJ;AA8WA;EA8CI,aAAA;EACA,uBAAA;AAzZJ;AA0WA;EAmDI,kBAAA;AA1ZJ;AAuWA;EAuDI,6BAAA;EACA,yBAAA;AA3ZJ;AA+ZA;EACE,SAAA;AA7ZF;AAgaA;EACE,4BAAA;EACA,6BAAA;AA9ZF;AAiaA;EACE,2BAAA;EACA,8BAAA;AA/ZF;AAkaA;EACE,6BAAA;AAhaF;AAmaA;EACE,6BAAA;AAjaF;AAgaA;EAII,wBAAA;AAjaJ;AAqaA;;EArnEE,qBAAA;EAwnEA,0BAAA;AAnaF;AAsaA;EA3nEE,qBAAA;EA6nEA,kCAAA;AApaF;AAuaA;EAhoEE,qBAAA;EAkoEA,oCAAA;AAraF;AAwaA;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;AAtaF;AAyaA;EACE,8BAAA;EACA,yBAAA;EACA,iBAAA;AAvaF;AA0aA;EACE,sBAAA;AAxaF;AA2aA;EACE,yBAAA;AAzaF;AA4aA;EACE,oBAAA;AA1aF;AA6aA;EACE,aAAA;EACA,4BAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AA3aF;AA8aA;EACE,wBAAA;EACA,iCAAA;EACA,WAAA;AA5aF;AAyaA;EAMI,wBAAA;AA5aJ;AAsaA;;EAWI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;AA7aJ;AA2ZA;EAsBI,cAAA;AA9aJ;AAkbA;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAhbF;AAmbA;EACE,wBAAA;EACA,iCAAA;AAjbF;AA+aA;EAvhEE,uBAAA;EA6hEE,gBAAA;EACA,mBAAA;EACA,UAAA;AAjbJ;AAqbA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAnbF;AAsbA;EACE,0BAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sIAAA;AApbF;AA0bA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAxbF;AA2bA;EACE,sBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAzbF;AA4bA;EACE,sBAAA;AA1bF;AA6bA;EACE,yBAAA;AA3bF;AA6bA;EACE,uBAAA;AA3bF;AA6bA;;EAEE,yBAAA;EACA,iBAAA;AA3bF;AA8bA;;EAEE,cAAA;EACA,eAAA;AA5bF;AA+bA;EACE,kBAAA;EACA,kBAAA;AA7bF;AAgcA;EACE,6BAAA;EACA,8BAAA;AA9bF;AAgcA;EACE,sBAAA;AA9bF;AAicA;;EAEE,4BAAA;AA/bF;AAkcA;EACE,oCAAA;AAhcF;AAmcA;EACE,qCAAA;AAjcF;AAocA;;EAEE,mBAAA;AAlcF;AAqcA;EACE,6BAAA;EACA,uBAAA;AAncF;AAscA;EACE,uBAAA;AApcF;AAucA;EAzmEE,yBAAA;AAqqDF;AAwcA;EACE,6BAAA;EACA,sBAAA;EACA,UAAA;EACA,QAAA;AAtcF;AAycA;EACE,6BAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;AAvcF;AA0cA;EACE;IAEI,8BAAA;EAzcJ;EA4cA;IACE,YAAA;EA1cF;AACF;AA6cA;EACE,YAAA;EACA,uBAAA;AA3cF;AA6cA;EACE,YAAA;EACA,uBAAA;AA3cF;AA8cA;EACE,2BAAA;AA5cF;AA+cA;EACE,YAAA;EACA,aAAA;AA7cF;AAgdA;EACE,uBAAA;AA9cF;AAidA;EACE,wBAAA;AA/cF;AAkdA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAhdF;AAmdA;EACE,iBAAA;EACA,UAAA;AAjdF;AAodA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAldF;AAqdA;EACE,iBAAA;EACA,eAAA;AAndF;AAsdA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,2BAAA;AApdF;AAudA;EACE,gBAAA;AArdF;AAwdA;EACE,oCAAA;AAtdF;AAydA;EACE,cAAA;EACA,iBAAA;AAvdF;AA0dA;EACE,qCAAA;EACA,yBAAA;EACA,eAAA;AAxdF;AA2dA;EACE,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAzdF;AAkdA;EAUI,gBAAA;EACA,2BAAA;EACA,yBAAA;AAzdJ;AA6cA;EAgBI,UAAA;EACA,SAAA;AA1dJ;AAycA;EAqBI,aAAA;EAtlFF,aAAA;EAwBA,mBAAA;EA8PA,uBAAA;EApBA,mBAAA;AA63DF;AAkcA;EAjkFE,aAAA;EA4BA,sBAAA;EAsOA,mBAAA;EA61EI,YAAA;EACA,8BAAA;AA1dN;AA2bA;EAiCQ,YAAA;EACA,WAAA;AAzdR;AA+dA;EACE,aAAA;EACA,YAAA;AA7dF;AAgeA;EACE,YAAA;EACA,2CAAA;EACA,2BAAA;EACA,cAAA;AA9dF;AAkeA;EACE,yBAAA;AAheF;AAmeA;EACE,gCAAA;AAjeF;AAoeA;EACE,4BAAA;AAleF;AAqeA;EACE,iCAAA;AAneF;AAseA;EACE,kCAAA;AApeF;AAueA;EACE,4BAAA;AAreF;AAweA;EACE,YAAA;AAteF;AAweA;EACE,yBAAA;AAteF;AAyeA;EACE,wBAAA;EACA,gCAAA;EACA,6BAAA;AAveF;AA0eA;EACE,iBAAA;AAxeF;AA2eA;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;AAzeF;AA4eA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AA1eF;AA6eA;EACE,mBAAA;EACA,gBAAA;AA3eF;AA8eA;EACE,mBAAA;EACA,iBAAA;AA5eF;AA+eA;EACE,cAAA;EACA,yBAAA;AA7eF;AAgfA;EACE,4BAAA;EACA,yBAAA;AA9eF;AAifA;EACE,4BAAA;EACA,yBAAA;EACA,uBAAA;AA/eF;AAkfA;EAx9EE,qCAAA;EAoBA,mBAAA;EAgBA,qBAAA;EAhDA,gBAAA;EAy+EA,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,2BAAA;AAhfF;AAkfA;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;AAhfF;AAmfA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAjfF;AAofA;EACE,gBAAA;EACA,yBAAA;AAlfF;AAqfA;;EAEE,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mCAAA;EACA,uBAAA;EACA,qCAAA;EACA,0BAAA;AAnfF;AAsfA;EACE,4BAAA;AApfF;AAufA;EACE,4BAAA;AArfF;AAwfA;EACE,kBAAA;EACA,iBAAA;AAtfF;AAyfA;EACE,kBAAA;EACA,iBAAA;AAvfF;AA0fA;EACE,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,oBAAA;EACA,0BAAA;AAxfF;AA2fA;EACE,6BAAA;EACA,sBAAA;EACA,6BAAA;AAzfF;AA4fA;EACE,sBAAA;AA1fF;AA6fA;EACE,uBAAA;AA3fF;AA8fA;EACE,oBAAA;AA5fF;AA+fA;EACE,mBAAA;AA7fF;AAggBA;EACE,mBAAA;AA9fF;AAigBA;EACE,sBAAA;EACA,sBAAA;AA/fF;AA6fA;EAII,YAAA;AA9fJ;AAkgBA;EACE,WAAA;AAhgBF;AAmgBA;EACE,0BAAA;AAjgBF;AAogBA;EACE,wCAAA;AAlgBF;AAqgBA;EACE,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;AAngBF;AAsgBA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AApgBF;AAqgBE;EACE,iCAAA;AAngBJ;AAqgBE;EACE,qBAAA;AAngBJ;AAsgBE;EACE,yBAAA;EACA,qBAAA;EACA,aAAA;AApgBJ;AAsgBE;EACE,cAAA;AApgBJ;AAsgBE;EACE,0BAAA;AApgBJ;AAwgBA;;EAEE,eAAA;AAtgBF;AAygBA;EACE,aAAA;EACA,qCAAA;AAvgBF;AA0gBA;EACE,4BAAA;AAxgBF;AA2gBA;EACE,6BAAA;EACA,sBAAA;EACA,uBAAA;AAzgBF;AA4gBA;;EAEE,2BAAA;AA1gBF;AA6gBA;EACE,qBAAA;AA3gBF;AA8gBA;EACE,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,qBAAA;EACA,4BAAA;AA5gBF;AA+gBA;EACE,4BAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,UAAA;AA7gBF;AAghBA;EACE,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;AA9gBF;AAihBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;AA/gBF;AAkhBA;EAEI,4BAAA;EACA,eAAA;AAjhBJ;AAqhBA;EACE,2BAAA;AAnhBF;AAkhBA;EAGI,4BAAA;EACA,eAAA;AAlhBJ;AAshBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAphBF;AAuhBA;EACE,4BAAA;EACA,eAAA;AArhBF;AAwhBA;EACE,qBAAA;EACA,iBAAA;EACA,UAAA;AAthBF;AAmhBA;EAKI,gBAAA;EACA,WAAA;AArhBJ;AAyhBA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAvhBF;AA0hBA;EACE,YAAA;AAxhBF;AAuhBA;EAII,WAAA;EACA,YAAA;EACA,kBAAA;AAxhBJ;AA4hBA;EACE,4BAAA;EACA,eAAA;AA1hBF;AA6hBA;EACE,aAAA;AA3hBF;AA8hBA;EACE,6BAAA;EACA,UAAA;EACA,SAAA;AA5hBF;AA+hBA;;EAEE,uBAAA;AA7hBF;AA+hBA;EACE,mCAAA;AA7hBF;AA4hBA;EAII,uBAAA;AA7hBJ;AAyhBA;EAOM,iBAAA;EACA,eAAA;AA7hBN;AAqhBA;EAWQ,YAAA;EACA,kBAAA;AA7hBR;AAihBA;EAgBQ,eAAA;AA9hBR;AAoiBA;EACE,kBAAA;AAliBF;AACA;;;CAGC;AAwiBD;EACE;IAEI,WAAA;IACA,cAAA;IACA,uBAAA;IACA,eAAA;EAviBJ;AACF;AACA;;;CAGC;AA4iBD;EACE;IAEI,WAAA;IACA,cAAA;IACA,uBAAA;IACA,eAAA;EA3iBJ;AACF;AACA;;;CAGC;AAgjBD;EACE;IAEI,WAAA;IACA,cAAA;IACA,uBAAA;IACA,eAAA;EA/iBJ;AACF;AACA;;;CAGC;AAojBD;EACE;IAEI,WAAA;IACA,cAAA;IACA,uBAAA;IACA,eAAA;EAnjBJ;AACF;AAujBA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AArjBF;AAyjBA;EACE,6BAAA;AAvjBF;AA0jBA;EACE,cAAA;AAxjBF;AA2jBA;EACE,iBAAA;EACA,oBAAA;AAzjBF;AA4jBA;EACE,eAAA;AA1jBF","sourcesContent":["html,\nbody,\n#root {\n  .d-flex();\n  .flex-column();\n  .squareSize();\n  .m-0();\n  .p-0();\n  font-size: small;\n  &#root {\n    overflow: hidden;\n  }\n}\n\nbody {\n  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;\n  overflow: hidden;\n}\n\nbody * {\n  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: 'NeueFrutigerWorldW02-Regular';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../public/NeueFrutigerWorldW02-Regular.woff2');\n}\n\n@philips-blue: #1474a4;\n@philips-gray: #eeeeee;\n@philips-green: #93c47d;\n@philips-orange: #f6b26b;\n@philips-yellow: #f3f66b;\n@philips-darkgray: darkgray;\n\n//Scroll bar Stylings\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #5a9dbf;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #5a9dbf;\n}\n\n//input control Stylings\n.incompatible {\n  border: 0.1rem solid #0000000d;\n  border-radius: 4px;\n  background-color: #f1f1f1;\n\n  & > div:first-child {\n    padding-left: 0.1rem !important;\n  }\n}\n\n.compatible {\n  padding-left: 0.15rem;\n}\n\n//to remove default increment/decremt buttons added by browser\ninput[type='number'] {\n  -moz-appearance: text-field;\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n}\n\nfieldset.inputFieldset,\n.inputFieldsetWithSearchValueMatched {\n  box-sizing: border-box;\n  border-radius: 4px;\n  border-width: 1px;\n  border-color: rgba(0, 0, 0, 0.1);\n  border-style: solid;\n  width: 100%;\n  height: fit-content;\n  padding-bottom: 4px !important;\n\n  input[type='text'],\n  input[type='number'] {\n    padding: 0.5rem;\n  }\n\n  & > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.6);\n    word-break: break-all;\n    display: flex;\n  }\n\n  &:focus-within {\n    border-color: #5a9dbf;\n  }\n\n  &:focus-within > legend.inputLegend {\n    color: @philips-blue;\n  }\n\n  &:hover:not(:focus):not(:focus-within) {\n    border-color: rgba(0, 0, 0, 0.87);\n  }\n\n  &:hover:not(:focus):not(:focus-within) > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.87);\n  }\n}\n\n.MuiOutlinedInput-root {\n  width: 100% !important;\n}\n\n.numeric-input-field input {\n  width: 5ch;\n  height: 1rem !important;\n}\n\nh6.sectionLayoutHeader {\n  margin: 0;\n  padding: 0.1rem;\n  font-weight: 500;\n  font-size: 1.25rem;\n  line-height: 1.6;\n  text-align: center;\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.summary {\n  display: grid !important;\n  grid-template-columns: 40% 1fr;\n}\n\n.shorten {\n  overflow: hidden !important;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.languageContainer {\n  font-size: 1rem !important;\n  padding: 0px 0px 0px 0px !important;\n  vertical-align: middle !important;\n  align-items: center !important;\n  border-radius: 0 !important;\n  width: max-content;\n  top: -1px !important;\n}\n\n.dailogFooter {\n  background: @dialogActionBackground;\n  border-top: 0.1rem solid @dialogActionDivider;\n}\n\n.navigateTabLabel {\n  writing-mode: tb-rl;\n  height: inherit;\n  cursor: pointer;\n\n  font-size: 1.25rem;\n  white-space: nowrap;\n}\n\n.tabDrawerMini {\n  width: 3rem;\n  height: inherit;\n  text-align: center;\n  background: #eeeeee;\n  z-index: 100;\n}\n\n.pinIcon {\n  font-size: 1.4rem !important;\n}\n\n.rotate180 {\n  transform: rotate(180deg);\n}\n\n.rotate270 {\n  transform: rotate(270deg);\n}\n\n.rotate90 {\n  transform: rotate(90deg);\n}\n\n.rotate0 {\n  transform: rotate(0deg);\n}\n\n// no with styles\n@dialogActionBackground: rgb(238, 238, 238);\n@dialogActionDivider: rgba(0, 0, 0, 0.12);\n\n.d-flex {\n  display: flex;\n}\n\n.d-inline-flex {\n  display: inline-flex;\n}\n\n.d-block {\n  display: block;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n\n.d-inline {\n  display: inline;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n\n.squareSize {\n  width: 100%;\n  height: 100%;\n}\n\n.w-0 {\n  width: 0%;\n}\n\n.w-25 {\n  width: 25%;\n}\n\n.w-50 {\n  width: 50%;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-25ch {\n  width: '25ch';\n}\n\n.w-10 {\n  width: 10%;\n}\n\n.w-20 {\n  width: 20%;\n}\n\n.w-40 {\n  width: 40%;\n}\n\n.w-45 {\n  width: 45%;\n}\n\n.w-60 {\n  width: 60%;\n}\n\n.w-90 {\n  width: 90%;\n}\n\n.mw-0 {\n  max-width: 0%;\n}\n\n.mw-25 {\n  max-width: 25%;\n}\n\n.mw-50 {\n  max-width: 50%;\n}\n\n.mw-100 {\n  max-width: 100%;\n}\n\n.mw-10 {\n  max-width: 10%;\n}\n\n.minh-100 {\n  min-height: 100%;\n}\n\n.h-0 {\n  height: 0%;\n}\n\n.h-25 {\n  height: 25%;\n}\n\n.h-50 {\n  height: 50%;\n}\n\n.h-100 {\n  height: 100%;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.m-0 {\n  margin: 0;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mr-0 {\n  margin-right: 0;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.p-0 {\n  padding: 0;\n}\n\n.p-5px {\n  padding: 5px;\n}\n\n.p-10px {\n  padding: 10px;\n}\n\n.p-20px {\n  padding: 20px;\n}\n.p-15px {\n  padding: 15px;\n}\n\n.p-1rem {\n  padding: 1rem;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-2 {\n  padding-top: 2px !important;\n}\n.pt-10 {\n  padding-top: 10px !important;\n}\n\n.pl-0 {\n  padding-left: 0;\n}\n\n.pr-0 {\n  padding-right: 0;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.py-0 {\n  .pt-0();\n  .pb-0();\n}\n\n.px-0 {\n  .pr-0();\n  .pl-0();\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflowX-auto {\n  overflow-x: auto;\n}\n\n.overflowY-auto {\n  overflow-y: auto;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n\n.ws-nowrap {\n  white-space: nowrap !important;\n}\n\n.vertical-middle {\n  vertical-align: middle;\n}\n\n.align-top {\n  align-items: flex-start;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.align-start {\n  align-items: start !important;\n}\n\n.alignself-center {\n  align-self: center;\n}\n\n.alignself-start {\n  align-self: self-start;\n}\n\n.justify-left {\n  justify-content: left;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-right {\n  justify-content: right;\n}\n\n.justify-spacebetween {\n  justify-content: space-between;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.warning {\n  color: #ff9800 !important;\n}\n\n.bottomUnset {\n  border-bottom: unset;\n}\n\n.rowFlex {\n  .d-flex();\n  .flex-row();\n}\n\n.colFlex {\n  .d-flex();\n  .flex-column();\n}\n\n.squareSize {\n  width: 100%;\n  height: 100%;\n}\n\n.flex-start {\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.position-absolute {\n  position: absolute;\n}\n\n.overflow-ellipsis {\n  text-overflow: ellipsis;\n}\n\n.zindex-100 {\n  z-index: 100;\n}\n\n.border-radius-0 {\n  border-radius: 0 !important;\n}\n\n.bg-philips-blue {\n  background-color: @philips-blue;\n}\n\n.bg-lightgray {\n  background-color: lightgray;\n}\n\n.bg-fadedGray {\n  background-color: #9b9b9b;\n}\n\n.bg-orange {\n  background-color: orange;\n}\n\n.b-0 {\n  border: 0;\n}\n\n.PhilipsBlue {\n  color: @philips-blue;\n}\n\n.auto-included-message {\n  font-size: 12px;\n  padding: 6px 0px 0px 0px;\n}\n\n.conflictDialog-root {\n  .header {\n    background: @philips-blue;\n    font-size: 1.2rem !important;\n    padding: 0.5rem !important;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n  }\n\n  .footer {\n    background: @dialogActionBackground;\n    border-top: 0.1rem solid @dialogActionDivider;\n  }\n\n  .tableHeader {\n    font-size: 1.2rem !important;\n  }\n\n  .selection {\n    .d-flex();\n    .align-center();\n    .justify-left();\n    .flex-nowrap();\n    min-height: 8vh;\n    border-bottom: solid 0.1rem @philips-blue;\n    word-wrap: normal !important;\n    font-size: 0.9rem !important;\n    font-weight: bold !important;\n  }\n\n  .rowText {\n    font-size: 0.8rem !important;\n    font-weight: bold !important;\n    word-break: break-all;\n    word-wrap: break-word;\n  }\n\n  .subTableHeader {\n    .ws-nowrap();\n    word-wrap: normal !important;\n    font-size: 0.9rem !important;\n    font-weight: bold !important;\n  }\n\n  .subRowText {\n    font-size: 0.75rem !important;\n    word-break: break-all;\n    word-wrap: break-word;\n  }\n\n  .tabCell {\n    padding: 0.2rem 0.3rem 0.2rem !important;\n  }\n\n  .tabHead {\n    padding: 0.1rem 0.3rem !important;\n  }\n\n  .conflictDialog-paper {\n    width: 45%;\n    height: 60vh;\n  }\n\n  .conflictTableInner-root {\n    margin-top: 0.2rem;\n    margin-bottom: 0.2rem;\n  }\n\n  .guardedConflict {\n    height: 40vh;\n  }\n\n  .selectionValue {\n    .d-flex();\n    .align-center();\n    .justify-left();\n    .text-left();\n    .vertical-middle();\n    padding: 0.2rem;\n  }\n\n  .selectionLabel {\n    .selectionValue();\n    .ws-nowrap();\n  }\n\n  .modelConflict-icon {\n    .warning();\n    .d-inline-flex();\n    .mw-10();\n    .align-center();\n    .vertical-middle();\n    .justify-center();\n    padding: 0.1rem;\n  }\n\n  .collapsibleTableRow {\n    & > * {\n      .bottomUnset();\n    }\n  }\n\n  .collapsibleTable-root {\n    height: 38vh;\n  }\n\n  .cancelIcon {\n    height: 1.3em;\n    width: 1.3em;\n    font-size: 1.3rem;\n    margin-right: 0.2em;\n  }\n\n  .conflictError {\n    .d-flex();\n    .align-center();\n    padding-top: 1em;\n  }\n\n  .productHeader {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(224, 224, 224, 1);\n    text-align: center;\n    font-weight: bold;\n    font-size: 1rem;\n    max-width: 100%;\n    color: @philips-blue;\n  }\n\n  .sectionSubheader {\n    font-weight: bold;\n    font-size: 0.95em;\n    padding: 6px 0px 4px 4px;\n    color: #333;\n    background-color: lightgray;\n  }\n\n  .productTableContainer {\n    max-width: 100%;\n    border: 1px solid rgba(224, 224, 224, 1);\n  }\n\n  .feature-column {\n    width: 20ch;\n    max-width: 150px;\n    border-right: 2px solid rgb(191 201 205 / 30%) !important;\n    font-size: 0.95rem;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .option-column {\n    width: 20ch;\n    max-width: 150px;\n    border-right: 2px solid rgb(191 201 205 / 30%) !important;\n    font-size: 0.95rem;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .description-column {\n    width: auto;\n    font-size: 0.95rem;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .feature-header {\n    font-weight: bold !important;\n    border-right: 2px solid rgb(191 201 205 / 30%) !important;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .description-header {\n    font-weight: bold !important;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .tableRow {\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.04);\n    }\n\n    &:nth-child(even) {\n      background-color: rgba(0, 0, 0, 0.02);\n    }\n  }\n}\n\n.AutoSelectedAssignmentDialog-root {\n  .header {\n    background: @philips-blue;\n    font-size: 1.2rem !important;\n    padding: 0.5rem !important;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n  }\n\n  .footer {\n    background: @dialogActionBackground;\n    border-top: 0.1rem solid @dialogActionDivider;\n\n    .checkbox-container {\n      display: flex;\n      align-items: center;\n\n      .MuiFormControlLabel-root {\n        margin: 0;\n\n        .MuiFormControlLabel-label {\n          font-size: 0.875rem;\n          color: rgba(0, 0, 0, 0.87);\n        }\n      }\n    }\n\n    .button-container {\n      display: flex;\n      gap: 8px;\n      align-items: center;\n    }\n  }\n\n  .AutoSelectedAssignmentDialog-paper {\n    overflow: hidden;\n    width: 45%;\n    height: 60vh;\n  }\n  .selectionValue {\n    .d-flex();\n    .align-center();\n    .justify-left();\n    .text-left();\n    .vertical-middle();\n    padding: 0.2rem;\n  }\n\n  .selectionLabel {\n    .selectionValue();\n    .ws-nowrap();\n  }\n  .selection {\n    .d-flex();\n    .align-center();\n    .justify-left();\n    .flex-nowrap();\n    min-height: 4vh;\n    border-bottom: solid 0.1rem @philips-blue;\n    word-wrap: normal !important;\n    font-size: 0.9rem !important;\n    font-weight: bold !important;\n    flex-shrink: 0;\n  }\n  .tableContainer {\n    border: 1px solid rgba(224, 224, 224, 1);\n    border-radius: 4px;\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  .productTableContainer {\n    max-width: 100%;\n    border: 1px solid rgba(224, 224, 224, 1);\n\n    .MuiTable-root {\n      table-layout: fixed;\n      width: 100%;\n    }\n  }\n\n  .tabCell {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n    border-right: 1px solid rgba(224, 224, 224, 1);\n    padding: 4px 4px;\n    font-size: 0.875rem;\n    line-height: 1.2;\n    letter-spacing: 0.01071em;\n\n    &:last-child {\n      border-right: none;\n    }\n\n    &.feature-column {\n      width: 150px;\n      min-width: 150px;\n      max-width: 150px;\n      font-size: 0.95rem;\n      word-wrap: break-word;\n      word-break: break-word;\n      white-space: normal;\n    }\n\n    &.option-column {\n      width: 150px;\n      min-width: 150px;\n      max-width: 150px;\n      font-size: 0.95rem;\n      word-wrap: break-word;\n      word-break: break-word;\n      white-space: normal;\n    }\n\n    &.description-column {\n      width: auto;\n      font-size: 0.95rem;\n      word-wrap: break-word;\n      word-break: break-word;\n      white-space: normal;\n    }\n  }\n\n  .tabHead {\n    background-color: #f5f5f5;\n    font-weight: 600;\n    border-bottom: 2px solid rgba(224, 224, 224, 1);\n    border-right: 1px solid rgba(224, 224, 224, 1);\n\n    &:last-child {\n      border-right: none;\n    }\n  }\n\n  .tableRow {\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.04);\n    }\n\n    &:nth-child(even) {\n      background-color: rgba(0, 0, 0, 0.02);\n    }\n  }\n\n  .noDataMessage {\n    color: rgba(0, 0, 0, 0.6);\n    font-style: italic;\n    padding: 2rem;\n    text-align: center;\n  }\n\n  .scrollableContent {\n    max-height: 354px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    .productSection {\n      margin-top: 2vh;\n      width: 41.6vw;\n\n      .MuiTable-root {\n        table-layout: fixed;\n        width: 100%;\n      }\n    }\n  }\n\n  .dialogContent {\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    max-height: 70vh;\n\n    .auto-included-message {\n      padding: 4px 0px 0px 0px;\n      flex-shrink: 0;\n      font-size: 12px;\n    }\n  }\n\n  .productHeader {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(224, 224, 224, 1);\n    text-align: center;\n    font-weight: bold;\n    font-size: 1.1rem;\n    max-width: 100%;\n    color: @philips-blue;\n  }\n\n  .sectionSubheader {\n    font-weight: bold;\n    font-size: 0.95em;\n    padding: 6px 0px 4px 4px;\n    color: #333;\n    background-color: lightgray;\n  }\n\n  .AutoSelectedAssignmentDialog-root .productId {\n    color: @philips-blue !important;\n    font-weight: bold !important;\n  }\n\n  .productTableContainer {\n    max-width: 100%;\n    border: 1px solid rgba(224, 224, 224, 1);\n  }\n\n  .feature-column {\n    width: 20ch;\n    max-width: 150px;\n    border-right: 2px solid rgb(191 201 205 / 30%) !important;\n    font-size: 0.95rem;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .option-column {\n    width: 20ch;\n    max-width: 150px;\n    border-right: 2px solid rgb(191 201 205 / 30%) !important;\n    font-size: 0.95rem;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .description-column {\n    width: auto;\n    font-size: 0.95rem;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .feature-header {\n    font-weight: bold !important;\n    border-right: 2px solid rgb(191 201 205 / 30%) !important;\n    font-size: 0.95rem;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .description-header {\n    font-weight: bold !important;\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n}\n\n.configurator-root {\n  padding-bottom: 5px !important;\n  &.root {\n    .colFlex();\n    .flex-start();\n    .squareSize();\n  }\n\n  .configurator-content {\n    .rowFlex();\n    .flex-start();\n    .squareSize();\n    flex-wrap: wrap;\n    height: 100% !important;\n  }\n\n  .configurator-content-with-disclaimer {\n    .rowFlex();\n    .flex-start();\n    .squareSize();\n    flex-wrap: wrap;\n    height: 93% !important;\n  }\n\n  .medium-configurator-content {\n    .rowFlex();\n    .flex-start();\n    .squareSize();\n    flex-wrap: wrap;\n    height: 94.5% !important;\n  }\n}\n\n.configurationSummary-root {\n  &.root {\n    .colFlex();\n    .flex-start();\n    .squareSize();\n    .overflow-auto();\n    padding: 0 5px;\n  }\n\n  &\n    > .MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded {\n    box-sizing: border-box;\n    border: 2px solid transparent;\n    border-radius: 4px;\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24);\n    background-color: #eee;\n  }\n\n  .MuiCollapse-root.MuiCollapse-vertical {\n    background-color: #fff;\n  }\n\n  & > .MuiPaper-elevation1.MuiAccordion-root {\n    &:first-of-type {\n      margin-top: 10px;\n    }\n\n    &:last-of-type {\n      margin-bottom: 10px;\n    }\n  }\n\n  .MuiAccordion-root.Mui-expanded {\n    margin: 10px 0 0;\n  }\n\n  & > .MuiPaper-elevation1.MuiAccordion-root {\n    img {\n      vertical-align: middle;\n      height: 1.5rem;\n      width: 2rem;\n      object-fit: scale-down;\n    }\n\n    .MuiAccordionSummary-content {\n      width: 90%;\n      justify-self: left;\n      align-items: center;\n    }\n\n    .MuiAccordionSummary-expandIconWrapper {\n      width: 10%;\n      justify-self: right;\n      justify-content: center;\n    }\n  }\n\n  .MuiAccordionSummary-content {\n    h6,\n    .modelPrice span {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    .modelPrice span {\n      margin-left: auto;\n    }\n\n    &.Mui-expanded {\n      .summary-accordionHead {\n        .summary-accordionHeadTitle {\n          word-wrap: break-word;\n          text-overflow: initial;\n          white-space: initial;\n          &.required:after {\n            display: inline;\n            content: '*';\n            color: red;\n          }\n        }\n        .asterisk {\n          display: none;\n        }\n      }\n      h6,\n      .modelPrice span {\n        word-wrap: break-word;\n        text-overflow: initial;\n        white-space: initial;\n      }\n    }\n  }\n}\n\n.configurationValidationDialog-root {\n  .header {\n    background: @philips-blue;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n    padding: 0.49rem !important;\n  }\n\n  .footer {\n    background: @dialogActionBackground;\n    border-top: 0.1rem solid @dialogActionDivider;\n  }\n\n  .message {\n    color: red;\n    font-size: 1rem !important;\n    font-weight: bold !important;\n    padding: 0.8rem 0.5rem;\n    overflow: hidden;\n    width: 100%;\n    text-overflow: ellipsis;\n  }\n\n  .tableHeader {\n    font-size: 1.3rem !important;\n    font-weight: bold !important;\n  }\n\n  .subRowText {\n    font-size: 0.8rem !important;\n    word-break: break-all;\n    word-wrap: break-word;\n  }\n\n  .rowText {\n    .subRowText();\n    font-weight: bold !important;\n  }\n\n  .removedSubRowText {\n    .subRowText();\n    color: red !important;\n  }\n\n  .subTableHeader {\n    font-size: 0.9rem !important;\n    font-weight: bold !important;\n  }\n\n  .tabCell {\n    padding: 0.5rem !important;\n  }\n\n  .configurationValidationDialog-paper {\n    width: 75% !important;\n    height: 75vh !important;\n  }\n\n  .innerTable {\n    .overflowY-auto();\n    .mx-auto();\n    height: 45vh;\n  }\n\n  .collapsibleTableRow {\n    & > * {\n      .bottomUnset();\n    }\n  }\n\n  .collapsibleTable {\n    .overflow-auto();\n    .mx-auto();\n    height: 45vh;\n  }\n\n  .tabSection-root {\n    border-bottom: 1px solid;\n    border-color: @dialogActionDivider;\n\n    .tab-button {\n      padding: 0.5rem;\n      text-transform: capitalize;\n      flex-direction: row;\n    }\n\n    .tab-badge {\n      text-align: center;\n      vertical-align: middle;\n      width: 1.5rem;\n      height: 1.5rem;\n      font-size: 0.8rem;\n      margin-left: 0.3rem;\n\n      &.selected {\n        background-color: @philips-blue;\n      }\n    }\n  }\n\n  .tabSection-panel {\n    padding: 0 1.3rem;\n    height: 48vh;\n  }\n}\n\n.footer {\n  &.root {\n    .d-flex();\n    width: 100%;\n    font-size: 12px;\n    justify-content: space-between;\n    padding-left: 1em;\n    padding-right: 1em;\n    align-items: center;\n  }\n\n  .env {\n    margin-right: 1px;\n    padding-right: 1px;\n  }\n\n  .termsAndCondition {\n    .d-flex();\n    .flex-row();\n    margin-right: 1px;\n  }\n\n  &.bg-gray {\n    background-color: @philips-gray;\n  }\n\n  &.bg-green {\n    background-color: @philips-green;\n  }\n\n  &.bg-orange {\n    background-color: @philips-orange;\n  }\n\n  &.bg-yellow {\n    background-color: @philips-yellow;\n  }\n}\n\n.termsAndCondition-dialog {\n  .paperClass {\n    width: 45%;\n    max-height: 60vh;\n    overflow-y: auto;\n  }\n}\n\n.termsAndConditionStyle {\n  .d-flex();\n  .flex-row();\n  margin-right: 1px;\n\n  .title {\n    .cursor-pointer();\n    text-decoration: underline;\n    color: blue;\n  }\n}\n\n.sectionLayout {\n  padding: 0px 20px;\n}\n\n.viewError {\n  margin: 20px 0px 0px 0px !important;\n}\n\n.userPanelIconButton {\n  .cursor-pointer();\n  color: white !important;\n  .p-5px() !important;\n\n  .userProfileIcon {\n    height: 2rem;\n    width: 2rem;\n  }\n}\n\n.popperStyle {\n  &.arrow {\n    width: 3em;\n    height: 3em;\n  }\n\n  &::before {\n    content: '';\n    margin: auto;\n    .d-block();\n    .w-0();\n    border-style: solid;\n    border-width: 0px 1em 1em;\n    border-color: transparent transparent rgb(255, 255, 255);\n    margin-top: -0.4rem;\n  }\n}\n\n.activeIcon {\n  color: @philips-gray !important;\n  .bg-philips-blue() !important;\n}\n\n.infoDialogIcon {\n  .m-0() !important;\n  padding: 3px !important;\n}\n\n.familyInfoDialogIcon {\n  padding: 3px !important;\n}\n\n.validation-error {\n  color: red !important;\n  overflow: hidden;\n  width: 100%;\n  text-overflow: ellipsis;\n  font-size: 1rem !important;\n}\n.success {\n  color: #9dc183 !important;\n}\n\n.txt-field {\n  padding: 0px 4px !important;\n  width: fit-content;\n}\n\n.bg-red {\n  background-color: red;\n}\n\n.color-red {\n  color: red;\n}\n\n.btn-ok {\n  float: right;\n  padding-top: 15px;\n}\n\n.btn-disabled {\n  color: @philips-gray;\n}\n\n.btn-decrement-disabled {\n  color: @philips-darkgray;\n}\n\n.btn-decrement {\n  color: #fa8072;\n}\n\n.btn-increment {\n  color: #9dc183;\n}\n\n.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.left-arrow {\n  color: @philips-blue;\n  margin-left: 80%;\n}\n\n.drawerOpen {\n  width: 200px;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {\n  .text-capitalize();\n  .align-center();\n  .justify-left();\n  .text-left();\n  min-height: 30px;\n  padding: 10px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.headerStyle {\n  &.root {\n    .rowFlex();\n    .flex-start();\n  }\n\n  .toolbar {\n    .rowFlex();\n    justify-content: space-between;\n    align-items: center;\n    .squareSize();\n    padding: 0 10px;\n    min-height: 3rem;\n    padding-top: 0.3rem !important;\n    padding-bottom: 0.3rem !important;\n  }\n\n  .toolbarSection {\n    .rowFlex();\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .tooltip {\n    margin: 2;\n  }\n\n  .button-icon {\n    .cursor-pointer();\n    color: #ffffff;\n  }\n\n  .message {\n    .stateIcon();\n    .colFlex();\n    line-height: 1.2;\n    color: #f7d368;\n  }\n\n  .headerBanner {\n    margin-left: 0.5em;\n    &.state {\n      &.readOnly {\n        .icon {\n          color: #d2cbcb !important;\n        }\n        .message {\n          color: #d2cbcb !important;\n        }\n      }\n    }\n  }\n\n  .icon {\n    height: 100% !important;\n    width: 2em !important;\n    color: #f7d368;\n  }\n}\n\n.orderingIntstuctionsStyle {\n  .table-container {\n    overflow-x: inherit;\n  }\n\n  .activeBorder {\n    border-bottom: 1px solid;\n    border-color: #00000033;\n  }\n\n  .inactiveBorder {\n    border-bottom: 0;\n  }\n\n  .table-cell {\n    border: 1px solid @philips-gray;\n    padding: 5px;\n  }\n}\n\n.languageSelectionDialogStyle {\n  .form-control {\n    margin: 20px 0 0 0;\n  }\n}\n\n.sectionStyle {\n  .title {\n    .m-0();\n    font-weight: 500;\n    font-size: 1.25rem;\n    line-height: 1.6;\n    word-break: break-all;\n  }\n\n  &,\n  .height-fit-content {\n    height: fit-content;\n  }\n}\n\n.infoDialogStyle {\n  .paper {\n    width: 80% !important;\n    height: 80vh !important;\n    max-width: 100% !important;\n  }\n\n  .summary {\n    width: 100%;\n    display: grid !important;\n    grid-template-columns: 40% 1fr;\n  }\n\n  .shorten {\n    overflow: hidden !important;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .title {\n    .align-center();\n    .h-auto();\n  }\n\n  .infoDialogTitle {\n    width: 90%;\n  }\n\n  .dialog-box {\n    border-bottom: 1px solid;\n    border-color: @dialogActionDivider;\n  }\n\n  .dialog-tab {\n    padding: 0.5rem;\n    .text-capitalize();\n    .flex-row();\n  }\n\n  .dialog-panel {\n    padding: 1rem;\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 60vh;\n    overflow-y: auto;\n    .mx-auto();\n    & .salesTextAccordion-root {\n      border: 1px solid @philips-gray;\n      border-top: none;\n      padding: 0;\n      margin: 0;\n      &:first-of-type {\n        border-top: 1px solid @philips-gray;\n        margin-top: 1rem;\n      }\n      .summary {\n        & > div {\n          padding: 0.2rem;\n        }\n        & .shorten {\n          color: @philips-blue;\n          .text-bold();\n          padding-left: 0.5rem;\n          border-left: 1px solid @philips-gray;\n          vertical-align: middle;\n          & > span {\n            color: black;\n            font-weight: normal;\n          }\n        }\n      }\n\n      .summary-expanded {\n        padding: 0.2rem;\n      }\n\n      .content {\n        padding: 0.2rem;\n      }\n    }\n  }\n\n  .MuiTabs-indicator {\n    height: 2px;\n  }\n\n  .imageGrid {\n    height: 100% !important;\n    padding: 24px;\n  }\n\n  .MuiDialogContent-root {\n    padding-bottom: 0px !important;\n  }\n}\n.error-dialog-style {\n  .MuiDialog-paper {\n    width: 25%;\n  }\n}\n\n.common-dialog-style {\n  .header {\n    .bg-philips-blue();\n    font-size: 1.2rem;\n    padding: 0.5rem;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n  }\n\n  .paper {\n    height: 60vh;\n  }\n\n  .closeIcon {\n    .position-absolute();\n    right: 8px;\n    top: 0px;\n    color: #fff;\n  }\n\n  .footer {\n    background: @dialogActionBackground;\n    border-top: 0.1rem solid @dialogActionDivider;\n  }\n}\n\n.dragger {\n  width: 5px;\n  cursor: ew-resize;\n  padding: 4px 0 0;\n  border-top: 1px solid #ddd;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 100;\n  background-color: #f4f7f9;\n}\n\n.drawer-class {\n  height: inherit;\n  overflow: hidden !important;\n  z-index: 1;\n}\n\n.infoPanelStyle {\n  &.root {\n    .d-flex();\n    .flex-column();\n    .justify-start();\n    .align-center();\n    height: 100%;\n    width: 100%;\n    transition: 0.15s;\n    padding: 10px;\n    overflow: hidden;\n    border-left: 1px solid @dialogActionDivider;\n    background: @dialogActionBackground;\n    min-width: 345px;\n    margin: 0;\n    flex-shrink: 0;\n  }\n  &.rootNew {\n    .root();\n    height: 80% !important;\n  }\n\n  &.mobileView {\n    .root();\n    height: 82% !important;\n  }\n\n  &.summaryViewHeight {\n    height: 91.5% !important;\n  }\n\n  .content {\n    overflow-wrap: anywhere;\n  }\n\n  &.disabled,\n  .disabled {\n    min-width: 0;\n    .w-0();\n    .p-0();\n    overflow: hidden;\n  }\n\n  .disabledContent {\n    .m-0();\n  }\n\n  &.hover {\n    .position-absolute();\n    right: 0;\n    bottom: 0;\n    box-shadow: -8px 0 8px -8px black;\n    z-index: 15;\n    height: unset;\n  }\n\n  .rootPrice {\n    .rowFlex1 {\n      .rowFlex();\n      justify-content: space-around;\n      align-items: center;\n    }\n\n    .w-100();\n    padding: 0 10px;\n  }\n\n  .title {\n    font-weight: 400;\n    font-size: 1.5rem;\n    line-height: 1.334;\n    margin: 1em 0px 10px 0px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.32);\n  }\n\n  .priceTitle {\n    font-weight: bold;\n    font-size: 1rem;\n    font-family: NeueFrutigerWorldW02-Regular;\n  }\n\n  .box-iconbtn {\n    color: @philips-blue;\n    .position-absolute();\n    .p-0();\n    .alignself-start();\n  }\n\n  .box-table {\n    margin-bottom: 5px;\n  }\n\n  &.extraSmallHeaderHeight {\n    top: 89px;\n  }\n\n  &.headerHeight {\n    top: inherit;\n  }\n  .box-openInbtn {\n    .position-absolute();\n    .p-0();\n    align-self: self-end;\n  }\n}\n\n.appRouter {\n  &.root {\n    .colFlex();\n    .flex-start();\n    .squareSize();\n    padding: 0;\n  }\n\n  .secondaryHeader {\n    .d-flex();\n    .flex-row();\n    .justify-spacebetween();\n    .align-center();\n    width: 100%;\n  }\n\n  .appRouterContent {\n    .d-flex();\n    .flex-row();\n    .justify-spacebetween();\n    .squareSize();\n    overflow: hidden;\n  }\n\n  .divider {\n    width: 100%;\n  }\n}\n\n.home-icon {\n  color: @philips-blue !important;\n  width: 100%;\n  padding: 3px !important;\n  margin: 0px !important;\n}\n\n.breadCrumb {\n  &.root {\n    .d-flex();\n    .flex-row();\n    .justify-start();\n    .align-center();\n    width: 100%;\n    padding: 0 10px;\n  }\n\n  .MuiBreadcrumbs-separator {\n    margin: 0px !important;\n  }\n\n  .item {\n    .PhilipsBlue();\n    text-overflow: ellipsis;\n    max-width: 15em;\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  .activeItem {\n    font-weight: bold;\n  }\n}\n\n.configureError {\n  .title {\n    color: #ff9800;\n    background: @philips-blue;\n    border-bottom: 1px solid @dialogActionDivider;\n    padding: 0px 8px;\n  }\n\n  .listItem {\n    margin: 0 0 0 20px;\n    list-style-type: disc;\n  }\n\n  .header {\n    background: @philips-blue;\n    font-size: 1.2rem !important;\n    padding: 0.5rem !important;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n  }\n\n  .footer {\n    background: @dialogActionBackground;\n    border-top: 1px solid @dialogActionDivider;\n  }\n\n  .dialogContent {\n    padding: 15px 15px 15px 15px;\n    min-width: 300px;\n  }\n}\n\n.variableSummary {\n  &.root {\n    .colFlex();\n    .flex-start();\n    width: 100%;\n    margin: 5px 0;\n  }\n\n  section {\n    .rowFlex();\n    .flex-start();\n    width: 100%;\n  }\n\n  content {\n    width: 100%;\n    overflow: hidden;\n  }\n\n  .tableCell {\n    width: 45%;\n    border: none;\n    word-break: break-all;\n  }\n\n  .headTableCell {\n    border: none;\n  }\n\n  .fullWidthborder {\n    border-bottom: 1px solid rgb(224, 224, 224);\n  }\n\n  .variableName {\n    .PhilipsBlue() !important;\n    font-weight: 800;\n    border: none;\n    padding-top: 0px;\n    padding-bottom: 1px;\n  }\n\n  .optionalValue {\n    color: darkgrey !important;\n  }\n}\n\n.sectionSummary {\n  &.root {\n    margin-top: 10px;\n    width: 100%;\n  }\n\n  &.content,\n  .content {\n    width: 100%;\n    font-weight: normal;\n  }\n\n  .contentHead {\n    font-size: 1rem;\n    margin: 0px;\n  }\n\n  .contentBody {\n    padding-left: 0.2rem;\n    font-size: 0.9rem;\n  }\n\n  .accordionHead {\n    font-size: 1rem;\n    font-weight: bold;\n    vertical-align: middle;\n    margin: 0px;\n  }\n\n  .summary-accordionHead {\n    font-size: 1rem;\n    font-weight: bold;\n    vertical-align: middle;\n    margin: 0px;\n    display: flex;\n    align-items: center;\n    .summary-accordionHeadTitle {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      &.required:after {\n        display: none;\n      }\n    }\n  }\n\n  .summaryAccordionHeader {\n    display: inline-flex;\n    width: 60%;\n    justify-content: left;\n    text-align: left;\n    justify-self: left;\n    align-items: center;\n    padding: 0;\n  }\n\n  .summary-accordianTitle {\n    display: flex;\n    width: 80%;\n  }\n\n  .modelPrice {\n    display: inline-flex;\n    max-width: 40%;\n    justify-content: right;\n    text-align: right;\n    align-items: center;\n    justify-self: right;\n    padding: 0;\n    margin-left: auto;\n    word-break: break-all;\n  }\n\n  .acSummary {\n    align-items: center;\n    min-height: 2.5rem !important;\n  }\n\n  .divider {\n    width: 90%;\n    .mx-auto();\n  }\n}\n.currencyContainer {\n  .symbol {\n    padding-left: 0.3rem;\n    font-size: 1.3rem !important;\n    margin: 0 0.5px;\n  }\n\n  svg {\n    font-size: 1.6rem !important;\n  }\n}\n\n.messagesIcon {\n  padding-top: 2px;\n\n  .messageBadge .MuiBadge-badge {\n    transform: scale(0.7) translate(30%, -30%) !important;\n  }\n}\n\n.orangeBadge {\n  .messageBadge .MuiBadge-badge {\n    .bg-orange();\n  }\n}\n\n.grayBadge {\n  .messageBadge .MuiBadge-badge {\n    .bg-fadedGray();\n  }\n}\n\n.popoverPaper .MuiPaper-root {\n  .d-flex();\n  .flex-column();\n}\n\n.eraserIcon {\n  min-width: 0px !important;\n  border-radius: 50% !important;\n  top: 0.5px !important;\n  .action-panel-buttons();\n}\n\n.eraserIcon:hover {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n}\n\n.stateIcon {\n  color: #f7d368;\n}\n\n.errorIcon {\n  color: #fa5a4b;\n  position: relative;\n  top: 4px;\n}\n\n.required:after {\n  content: '*';\n  font-weight: bold;\n  color: red;\n}\n\n.asterisk {\n  font-weight: bold;\n  color: red;\n}\n\n.priceHeader {\n  padding-right: 0.5em;\n}\n\n.clearAllButton {\n  margin-left: -0.3em !important;\n}\n\n.noSelectableMessage {\n  justify-content: center;\n  width: 100%;\n}\n\n.noTextMessage {\n  display: flex;\n  justify-content: center;\n  height: -webkit-fill-available;\n  align-items: center;\n}\n\n.myConfigurations-Tab {\n  width: 84%;\n  display: block;\n  padding: 0px 0px 10px 10px;\n  overflow: auto;\n}\n\n.myConfigurations-list-Tab {\n  height: calc(87% - 4.6rem);\n  display: block;\n  overflow: auto;\n  margin-top: 6px;\n}\n\n.list-Section {\n  display: block;\n  height: calc(86% - 4.6rem);\n  overflow: auto;\n  padding: 0px 10px 10px 10px;\n  ul > div {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n}\n\n.list-Section-Tab {\n  display: block;\n  width: 84%;\n  overflow: auto;\n}\n\n.list-Section::-webkit-scrollbar {\n  height: 10px;\n}\n\n.landing-Page {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.list-Items {\n  padding-top: 0px !important;\n}\n\n.prod-list {\n  color: @philips-blue !important;\n  text-decoration: underline !important;\n  max-width: 300px !important;\n  padding-bottom: 4px !important;\n  padding-left: 0px !important;\n  padding-top: 4px !important;\n  word-break: break-all;\n}\n\n.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-endAdornment {\n  right: 0 !important;\n\n  .MuiIconButton-root {\n    margin-right: 0;\n    padding: 8px;\n  }\n}\n\n.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\n  height: 1rem;\n}\n\n.search-bar.MuiAutocomplete-root {\n  width: 20em !important;\n  position: relative;\n  bottom: 3px;\n  right: 5.5px;\n\n  padding-top: 0.5rem;\n\n  .search-inner-text > div {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n\n  .search-inner-text > div > div > button {\n    // To make the clear icon visible\n    visibility: visible !important;\n  }\n}\n\n.search-bar {\n  margin: 0px !important;\n}\n\n.create-configuration-dialog {\n  .MuiDialog-container .MuiPaper-root {\n    width: 100%;\n    max-width: 30%;\n    height: auto !important;\n    max-height: 65%;\n  }\n\n  .MuiDialog-container .MuiPaper-root .MuiDialogContent-root {\n    padding-top: 1.5em;\n  }\n\n  .errorMessage {\n    margin-top: 0.5vh;\n    max-width: unset !important;\n    height: unset !important;\n  }\n\n  .formActionButtons {\n    display: flex;\n    justify-content: flex-end;\n    bottom: 0;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    padding-bottom: 1em;\n    padding-right: 1.5em;\n\n    button {\n      margin-right: 0.5em;\n    }\n  }\n}\n\n.headers {\n  background: @philips-blue;\n  font-size: 1.2rem !important;\n  padding: 0.5rem !important;\n  border-bottom: 0.1rem solid @dialogActionDivider;\n  color: white;\n}\n\n.MuiTabPanel-root {\n  padding-left: 16px !important;\n  padding-top: 0px !important;\n}\n\n.detailedSummaryDialogStyle {\n  .paper {\n    width: 85% !important;\n    height: 110vh !important;\n    max-width: 100% !important;\n  }\n\n  .summary {\n    width: 100%;\n    display: grid !important;\n    grid-template-columns: 40% 1fr;\n  }\n\n  .shorten {\n    overflow: hidden !important;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .title {\n    .h-auto();\n    text-align: center;\n  }\n\n  .check {\n    padding: 0 !important;\n  }\n\n  .contents {\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n  }\n\n  .leftBar,\n  .leftBar-mobile {\n    border-right: 1px solid rgba(224, 224, 224, 1);\n    width: 20%;\n\n    .MuiAutocomplete-inputRoot {\n      border-radius: 0;\n    }\n\n    .defaultExpandIcon {\n      color: #0062a1;\n    }\n\n    .defaultCollapseIcon {\n      color: #0078ce;\n    }\n\n    .defaultEndIcon {\n      color: #00abeb;\n    }\n\n    .detailedSummaryTree {\n      height: 90%;\n      max-width: 100%;\n      overflow-y: auto;\n    }\n\n    .detailedSummarySearchBar {\n      width: 100% !important;\n      margin: 0px !important;\n      .innerTextField > div {\n        // To remove unwanted padding to the search bar\n        padding-top: 0% !important;\n        padding-bottom: 0% !important;\n      }\n\n      .innerTextField > div > div > button {\n        // To make the clear icon visible\n        visibility: visible !important;\n      }\n    }\n  }\n\n  .leftBar-mobile {\n    overflow: hidden;\n  }\n\n  .rightBar {\n    width: 100% !important;\n    height: 100% !important;\n    display: flex; // To stick the total price at bottom\n    flex-direction: column;\n    justify-content: space-between;\n\n    .tableHead {\n      position: sticky;\n      top: 0;\n    }\n\n    .MuiTableCell-root {\n      vertical-align: baseline;\n    }\n\n    .PriceFooter {\n      display: flex;\n      background-color: #1d93cf;\n      color: #fff;\n      text-align: left;\n      padding-top: 0.5em;\n      padding-bottom: 0.5em;\n      font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n      font-weight: 500;\n      font-size: 0.875rem;\n      -height: 1.5rem;\n      letter-spacing: 0.01071em;\n      vertical-align: inherit;\n      text-align: left;\n      -content: space-between;\n      padding-left: 16px;\n      padding-right: 16px;\n    }\n\n    tbody th {\n      padding-top: 0.2em;\n      padding-bottom: 0em;\n      border: 0;\n    }\n\n    .totalPrice {\n      position: fixed;\n      top: 103vh;\n      bottom: 0;\n      width: -webkit-fill-available;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      border-top: 1px solid rgba(224, 224, 224, 1);\n      background-color: #1d93cf;\n      color: white !important;\n      th {\n        color: #fff !important;\n      }\n    }\n\n    .sectionRow {\n      background: #eeee;\n    }\n  }\n\n  .dialog-box {\n    border-bottom: 1px solid;\n    border-color: @dialogActionDivider;\n  }\n\n  .dialog-panel {\n    padding: 1rem;\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 53vh;\n    overflow-y: auto;\n    .mx-auto();\n    & .salesTextAccordion-root {\n      border: 1px solid @philips-gray;\n      border-top: none;\n      padding: 0;\n      margin: 0;\n      &:first-of-type {\n        border-top: 1px solid @philips-gray;\n        margin-top: 1rem;\n      }\n      .summary {\n        & > div {\n          padding: 0.2rem;\n        }\n        & .shorten {\n          color: @philips-blue;\n          .text-bold();\n          padding-left: 0.5rem;\n          border-left: 1px solid @philips-gray;\n          vertical-align: middle;\n          & > span {\n            color: black;\n            font-weight: normal;\n          }\n        }\n      }\n\n      .summary-expanded {\n        padding: 0.2rem;\n      }\n\n      .content {\n        padding: 0.2rem;\n      }\n    }\n  }\n}\n\n.action-panel-dialog-content {\n  padding-top: 1em !important;\n  padding-bottom: 1em !important;\n  p {\n    letter-spacing: 0px !important;\n  }\n}\n\n.configurationAccordian {\n  .img {\n    height: 75px;\n    width: auto;\n  }\n\n  .imageFlex {\n    width: 5%;\n    min-width: 30px;\n    text-align: left !important;\n  }\n\n  .productIdFlex {\n    width: 7%;\n    min-width: 100px;\n    text-align: left !important;\n  }\n\n  .productDescriptionFlex {\n    width: 25%;\n    min-width: 100px;\n    text-align: left !important;\n  }\n\n  .configIdFlex {\n    width: 15%;\n    min-width: 100px;\n    text-align: left !important;\n  }\n  .stateFlex {\n    width: 7%;\n    min-width: 100px;\n    text-align: left !important;\n  }\n\n  .dateFlex {\n    width: 25%;\n    min-width: 100px;\n    text-align: left !important;\n  }\n\n  .tableCellLeft {\n    text-align: left !important;\n  }\n\n  .imageCenter {\n    display: flex;\n    justify-content: center;\n  }\n\n  .accordionIcon {\n    margin-right: 10px;\n  }\n\n  .myConfigPanel {\n    overflow-x: 'auto !important';\n    height: '40vh !important';\n  }\n}\n\n.zoom80 {\n  zoom: 80%;\n}\n\n.action-panel-buttons {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.paddingTopBottom {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.sales-text-dialog {\n  padding-left: 10px !important;\n}\n\n.ordering-instructions-dialog {\n  padding-left: 10px !important;\n\n  .MuiTableCell-root {\n    padding: 1rem !important;\n  }\n}\n\n.iconCheck,\n.updateIcon {\n  .p-0() !important;\n  margin: 0px 4px !important;\n}\n\n.iconNumeric {\n  .p-0() !important;\n  margin: 0px 4px 0px 0px !important;\n}\n\n.submodelIcon {\n  .p-0() !important;\n  margin: 0.5px 8px 0px 0px !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {\n  color: #1474a4 !important;\n  background: rgba(199, 224, 244, 1) !important;\n  font-weight: 800 !important;\n}\n\n.MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused {\n  background: rgba(199, 224, 244, 1) !important;\n  color: #1474a4 !important;\n  font-weight: bold;\n}\n\n.closeWithoutSave-icon {\n  color: gray !important;\n}\n\n.notify-icon {\n  color: @philips-blue!important;\n}\n\n#demo-simple-select-label {\n  top: -6px !important;\n}\n\n.cardLayoutMainDiv {\n  display: flex;\n  justify-content: space-start;\n  padding: 0px;\n  align-items: center;\n  margin: -12px;\n  width: 100%;\n}\n\n.cardLayoutChildProdDiv {\n  display: flex !important;\n  flex-direction: column !important;\n  width: 100%;\n\n  .InnoSight.System {\n    display: flex !important;\n  }\n\n  .product-description,\n  .product-id {\n    color: @philips-blue;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: inline-block;\n    vertical-align: baseline;\n    line-height: 1.2;\n  }\n\n  .product-description {\n    max-width: 65%;\n  }\n}\n\n.overflow-country {\n  white-space: nowrap;\n  width: 125px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cardLayoutChildDiv {\n  display: flex !important;\n  flex-direction: column !important;\n\n  .configurationName {\n    .overflow-ellipsis();\n    overflow: hidden;\n    white-space: nowrap;\n    width: 95%;\n  }\n}\n\n.fullScreenImage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30vh !important;\n  width: auto;\n  text-align: center;\n  position: relative;\n}\n\n.fullScreenImage img {\n  max-width: 100% !important;\n  max-height: 100% !important;\n  pointer-events: none;\n  width: fit-content;\n  height: fit-content;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  box-shadow:\n    0 13px 27px -5px hsla(240, 30.1%, 28%, 0.25),\n    0 8px 16px -8px hsla(0, 0%, 0%, 0.3),\n    0 -6px 16px -6px hsla(0, 0%, 0%, 0.03);\n}\n\n.slider-wrapper {\n  width: 97%;\n  height: 15%;\n  margin-top: 2rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slick-slide img {\n  padding-inline: 0.5rem;\n  cursor: pointer;\n  max-width: 100%;\n  height: auto;\n}\n\n.slick-slide img:hover {\n  transform: scale(1.12);\n}\n\n.slick-next {\n  right: -1.5rem !important;\n}\n.slick-prev {\n  right: -30px !important;\n}\n.slick-next:before,\n.slick-prev:before {\n  color: @philips-blue !important;\n  font-weight: bold;\n}\n\n.next-slick-arrow,\n.prev-slick-arrow {\n  color: #000000;\n  font-size: 3rem;\n}\n\n.slick-slide {\n  text-align: center;\n  position: relative;\n}\n\n.slick-slider {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n.slick-prev {\n  left: -19px !important;\n}\n\n.breadcrumbs-li,\n.MuiBreadcrumbs-li {\n  display: contents !important;\n}\n\n.text-uppecase {\n  text-transform: uppercase !important;\n}\n\n.arrowIcon {\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.slick-prev,\n.slick-next {\n  top: 50% !important;\n}\n\n.productImageDialog {\n  overflow-y: hidden !important;\n  height: auto !important;\n}\n\n.noImageGrid {\n  height: 60vh !important;\n}\n\n.exportIcon {\n  .PhilipsBlue() !important;\n}\n\n.detailedExportIcon {\n  position: absolute !important;\n  color: #fff !important;\n  right: 2em;\n  top: 0px;\n}\n\n.quickExportIcon {\n  position: absolute !important;\n  padding: 0 !important;\n  align-self: self-end !important;\n  margin-right: 1.5em !important;\n}\n\n@media only screen and (max-width: 450px) {\n  .detailedSummaryDialogStyle {\n    .title {\n      text-align: inherit !important;\n    }\n  }\n  .detailedExportIcon {\n    right: 1.5em;\n  }\n}\n\n.product-portfolio {\n  height: 100%;\n  padding: 0px !important;\n}\n.myConfiguration-tab {\n  height: 100%;\n  padding: 0px !important;\n}\n\n.list-ItemsContainer {\n  margin-left: 0px !important;\n}\n\n.catalog-Container {\n  width: 400px;\n  height: 125px;\n}\n\n.catalog-cardLayout {\n  padding: 5px !important;\n}\n\n.catalog-cardLayout > div {\n  display: flex !important;\n}\n\n.catalog-image {\n  height: 80px;\n  width: 80px;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n\n.catalog-info {\n  margin-left: 10px;\n  width: 70%;\n}\n\n.catalog-productDescription {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 30ch;\n}\n\n.noDataAvailable-label {\n  margin-left: 18px;\n  margin-top: 7px;\n}\n\n.noData-label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: calc(100vh - 200px);\n}\n\n.catalog-create-div {\n  margin-top: 20px;\n}\n\n.catalog-create {\n  background-color: @philips-blue !important;\n}\n\n.productCatalogCardHeader {\n  color: rgb(20, 116, 164);\n  font-weight: bold;\n}\n\n.configName {\n  text-decoration: underline !important;\n  color: #0000ee !important;\n  cursor: pointer;\n}\n\n.unsupported-browser {\n  z-index: 150000 !important;\n  display: inline-block;\n  text-align: center;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n\n  .message {\n    text-align: left;\n    padding-top: 5px !important;\n    white-space: break-spaces;\n  }\n\n  .unsupported-browser-image {\n    height: 50;\n    width: 40;\n  }\n\n  .versionSupported {\n    padding: 10px;\n    .d-flex();\n    .flex-row();\n    .justify-center();\n    .align-center();\n    .browserBox {\n      .d-flex();\n      .flex-column();\n      .align-center();\n      margin: 0 2%;\n      justify-content: space-between;\n      img {\n        height: 35px;\n        width: 35px;\n      }\n    }\n  }\n}\n\n.product-portfolio-container {\n  display: flex;\n  height: 100%;\n}\n\n.hierarchy-container {\n  width: 200px;\n  border-right: 1px solid rgba(0, 0, 0, 0.12);\n  height: calc(100% - 5.6rem);\n  overflow: auto;\n}\n\n//for making parent filter color blue\n.filter-treeview > .filter-container > div > div > label > span:nth-child(2) {\n  color: @philips-blue !important;\n}\n\n.filter-treeview .filter-container {\n  margin-bottom: 0.7rem !important;\n}\n\n.filter-label {\n  margin-right: 0px !important;\n}\n\n.filter-label > span:nth-child(2) {\n  word-break: break-word !important;\n}\n\n.filter-container > .MuiTreeItem-content {\n  background-color: white !important;\n}\n\n.filter-checkbox.Mui-checked ~ span {\n  font-weight: bold !important;\n}\n\n.recordsPerPage {\n  height: 30px;\n}\n.recordsPerPage > div {\n  padding: 8.5px !important;\n}\n\n.error-header {\n  display: flex !important;\n  align-items: baseline !important;\n  flex-wrap: inherit !important;\n}\n\n.errorProduct-header {\n  margin-left: 10px;\n}\n\n.recordsChange-conatiner {\n  display: flex;\n  flex-direction: row-reverse;\n  margin-right: 10px;\n}\n\n.catalog-pagination {\n  align-items: center;\n  margin-top: 15px;\n  position: relative;\n  right: 120px;\n}\n\n.myConfig-pagination {\n  align-items: center;\n  margin-top: 12px;\n}\n\n.inputFieldsetWithSearchValueMatched {\n  border-color: black;\n  font-weight: bold;\n}\n\n.inputFieldsetWithSearchValueMatched > legend > span:nth-child(1) {\n  color: #000000;\n  background-color: #f3f66b;\n}\n\n.SearchValueMatched > span:nth-child(2) {\n  font-weight: bold !important;\n  background-color: #f3f66b;\n}\n\n.multiNumericFieldSetSearchValueMatched > legend > span:nth-child(1) {\n  font-weight: bold !important;\n  background-color: #f3f66b;\n  color: black !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-SearchValueMatched {\n  .text-capitalize();\n  .align-center();\n  .justify-left();\n  .text-left();\n  min-height: 30px;\n  padding: 10px;\n  color: rgba(0, 0, 0, 0.87) !important;\n  font-weight: 800 !important;\n}\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-SearchValueMatched {\n  color: #1474a4 !important;\n  background: rgba(199, 224, 244, 1) !important;\n  font-weight: 800 !important;\n}\n\n.result-found {\n  width: max-content;\n  padding-top: 5px;\n  margin-right: 10px;\n}\n\n.display-options-header {\n  position: sticky;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.add-product-action,\n.disable-product-action {\n  padding: 0px !important;\n  width: 320px !important;\n  height: 40px !important;\n  margin-top: 7px !important;\n  background-color: orange !important;\n  color: black !important;\n  text-transform: capitalize !important;\n  font-size: 1rem !important;\n}\n\n.disable-product-action > span:nth-child(1) {\n  margin-right: 3px !important;\n}\n\n.add-product-action > span:nth-child(1) {\n  margin-right: 3px !important;\n}\n\n.add-product-action > span {\n  width: max-content;\n  margin-right: 2px;\n}\n\n.disable-product-action > span {\n  width: max-content;\n  margin-right: 2px;\n}\n\n.cart-icon {\n  height: 20px !important;\n  width: 20px !important;\n  margin-right: 5px !important;\n  position: relative !important;\n  left: 6px !important;\n  font-size: 25px !important;\n}\n\n.refresh-button {\n  position: relative !important;\n  bottom: 4px !important;\n  margin-right: 10px !important;\n}\n\n.refresh-button > span {\n  margin: 0px !important;\n}\n\n.Country-Label > div {\n  padding: 4px !important;\n}\n\n.Country-Label > label {\n  top: -7px !important;\n}\n\n.Country-Label > .MuiFormLabel-filled {\n  top: 0px !important;\n}\n\n.Country-Label > .Mui-focused {\n  top: 0px !important;\n}\n\n.countryCode {\n  width: 100% !important;\n  margin: 0px !important;\n  .MuiOutlinedInput-root .MuiAutocomplete-endAdornment .MuiIconButton-root {\n    padding: 6px;\n  }\n}\n\n.hyphen {\n  color: grey;\n}\n\n.headerLogo {\n  cursor: pointer !important;\n}\n\n.infoDialogIconHighlight {\n  box-shadow: inset 0px 0px 1px 1px orange;\n}\n\n.preferenceDialog {\n  width: 80% !important;\n  height: auto !important;\n  max-height: 80vh !important;\n  max-width: 100% !important;\n}\n\n.inputFieldset {\n  box-sizing: border-box;\n  border-radius: 4px;\n  border-width: 1.5px;\n  border-color: rgba(0, 0, 0, 0.2);\n  border-style: solid;\n  width: 100% !important;\n  height: fit-content;\n  padding-bottom: 4px !important;\n  padding-left: 0.8rem !important;\n  &:hover:not(:focus):not(:focus-within) {\n    border-color: rgba(0, 0, 0, 0.87);\n  }\n  &:focus-within {\n    border-color: #1173a3;\n  }\n\n  & > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.6);\n    word-break: break-all;\n    display: flex;\n  }\n  &:focus-within > legend.inputLegend {\n    color: @philips-blue;\n  }\n  &:hover:not(:focus):not(:focus-within) > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.87);\n  }\n}\n\n.preference-container,\n.logout-container {\n  cursor: pointer;\n}\n\n.radio-group {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.margin-default {\n  margin-left: 16px !important;\n}\n\n.popperPage {\n  position: relative !important;\n  right: 10px !important;\n  width: 135px !important;\n}\n\n.messagesTable th,\ntr > td {\n  font-size: small !important;\n}\n\n.invalidCurrency {\n  color: red !important;\n}\n\n.baseModelName {\n  color: #1474a4 !important;\n  font-size: 0.975rem !important;\n  border-bottom: none !important;\n  width: 65% !important;\n  padding-left: 5px !important;\n}\n\n.baseModelPriceCell {\n  padding-left: 5px !important;\n  font-size: 1rem !important;\n  text-align: right !important;\n  border-bottom: none !important;\n  word-break: break-all;\n  width: 45%;\n}\n\n.table-cell-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 60ch !important;\n  display: table-cell !important;\n}\n\n.table-cell-overflow-mobile {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 60ch !important;\n  display: table-cell !important;\n}\n\n.icon-font-size {\n  svg {\n    font-size: 1.6rem !important;\n    margin: 0 0.5px;\n  }\n}\n\n.search-icon {\n  margin-left: 0px !important;\n  svg {\n    font-size: 1.6rem !important;\n    margin: 0 0.5px;\n  }\n}\n\n.rest-icon {\n  width: 22px;\n  height: 22px;\n  margin: 0 0.5px;\n}\n\n.nonce-1k33q06 {\n  font-size: 1.3rem !important;\n  margin: 0 0.5px;\n}\n\n.disclaimer {\n  word-wrap: break-word;\n  font-weight: bold;\n  padding: 0;\n  p {\n    padding-top: 3px;\n    margin: 0px;\n  }\n}\n\n.disclaimer-addproduct {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n\n.summary-view {\n  height: 100%;\n\n  .add-product-btn {\n    width: 100%;\n    margin: auto;\n    text-align: center;\n  }\n}\n\n.crumb-font-size {\n  font-size: 1.1rem !important;\n  margin: 0 0.5px;\n}\n\n.tree-group {\n  display: flex;\n}\n\n.filter-button {\n  position: absolute !important;\n  right: 0px;\n  top: -3px;\n}\n\n.nonce-8ver8g-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input,\n.nonce-1mijcsb-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\n  padding: 0px !important;\n}\n.collapsed {\n  margin: 0px 0px 0px 15px !important;\n\n  .Mui-disabled.MuiInputBase-fullWidth.MuiInputBase-formControl {\n    padding: 0px !important;\n\n    .MuiChip-sizeMedium.MuiChip-colorDefault.MuiChip-deletable {\n      padding-left: 3px;\n      font-size: 13px;\n\n      span {\n        padding: 0px;\n        padding-right: 7px;\n      }\n\n      svg {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n.loader-placeholder {\n  text-align: center;\n}\n\n// Media queries\n\n/* \n  ##Device = Tablets, Ipads (portrait)\n  ##Screen = B/w 768px to 1024px\n*/\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .create-configuration-dialog {\n    .MuiDialog-container .MuiPaper-root {\n      width: 100%;\n      max-width: 50%;\n      height: auto !important;\n      max-height: 65%;\n    }\n  }\n}\n\n/* \n  ##Device = Tablets, Ipads (landscape)\n  ##Screen = B/w 768px to 1024px\n*/\n\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n  .create-configuration-dialog {\n    .MuiDialog-container .MuiPaper-root {\n      width: 100%;\n      max-width: 50%;\n      height: auto !important;\n      max-height: 65%;\n    }\n  }\n}\n\n/* \n  ##Device = Low Resolution Tablets, Mobiles (Landscape)\n  ##Screen = B/w 481px to 767px\n*/\n\n@media (min-width: 481px) and (max-width: 767px) {\n  .create-configuration-dialog {\n    .MuiDialog-container .MuiPaper-root {\n      width: 100%;\n      max-width: 55%;\n      height: auto !important;\n      max-height: 65%;\n    }\n  }\n}\n\n/* \n  ##Device = Most of the Smartphones Mobiles (Portrait)\n  ##Screen = B/w 320px to 479px\n*/\n\n@media (min-width: 320px) and (max-width: 480px) {\n  .create-configuration-dialog {\n    .MuiDialog-container .MuiPaper-root {\n      width: 100%;\n      max-width: 60%;\n      height: auto !important;\n      max-height: 65%;\n    }\n  }\n}\n\n.headerLogoButton {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n// Custom tooltip positioning\n.dynamic-input-tooltip {\n  margin-left: 2.5em !important;\n}\n\n.warningIcon {\n  color: #f7d368;\n}\n\n.warning-icon-box {\n  margin-right: 4px;\n  display: inline-flex;\n}\n\n.assignment-section {\n  margin-top: 2vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
